import React, { useEffect, useState, useRef ,useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {  faChevronDown, faImage, faPaperclip, faPlus, faPlusCircle, faTrash, faX ,faSearch} from '@fortawesome/free-solid-svg-icons';
import {Loader} from '../Loader/Loader';
import { FaRegTrashAlt } from 'react-icons/fa';
import { Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import { useLocation, useNavigate } from 'react-router-dom';
import  '../Css/Tooltip.css';
import Search from '../Components/Search';
import useAutoScroll from '../Components/UseAutoScroll';
import { decryptData } from '../../utils/storageCrypto';

 
const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};


const CustomDropdown = ({ options, selected, onSelect, disabled = false, placeholder = "Select..." }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setIsOpen(false));

  const handleOptionClick = (value) => {
    const selectedOption = options.find(option => option.value === value);
    if (selectedOption) {
      onSelect(selectedOption.value, selectedOption.label);
    }
    setIsOpen(false);
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* HEADER WITH PLACEHOLDER */}
      <div
        className={`flex justify-between items-center p-1.5 border bg-white border-gray-300 rounded-md cursor-pointer hover:border-blue-400 hover:shadow-sm transition-all ${
          disabled ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''
        }`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span className={`text-sm truncate}`  }>
          {selected?.label || selected || placeholder}
        </span>
        <FontAwesomeIcon 
          icon={faChevronDown} 
          className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
        />
      </div>
      
      {/* DROPDOWN */}
      {isOpen && !disabled && (
        <div className="absolute mt-1 w-full max-h-48 bg-white border border-gray-300 rounded-md shadow-lg z-20 overflow-hidden">
          <div className="overflow-y-auto py-1 max-h-48">
            {options.length === 0 ? (
              <div className="px-3 py-2 text-center text-gray-500 text-xs">
                No options available
              </div>
            ) : (
              options.map((option, index) => 
                option.value !== 'add-new' && (
                  <div key={option.value || index} className="px-2">
                    <div
                      className={`py-1.5 pl-2 pr-3 cursor-pointer text-sm rounded transition-all hover:bg-blue-50 hover:text-blue-700 ${
                        selected?.value === option.value || selected === option.value
                          ? 'bg-blue-500 text-white font-medium border-r-2 border-blue-400'
                          : ''
                      }`}
                      onClick={() => handleOptionClick(option.value)}
                    >
                      {option.icon && <FontAwesomeIcon icon={option.icon} className="text-xs mr-2" />}
                      <span className="truncate">{option.label}</span>
                    </div>
                  </div>
                )
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// Add this component at the top of ViewProductDetails, after the CustomDropdown
const InputWithUnit = ({ value, onChange, unit, onUnitChange, units, readOnly = false }) => {
  return (
    <div className="flex w-full max-w-[160px]"> {/* Reduced from 220px to 160px - fits better */}
      <style>{`
        .no-spinner-input::-webkit-outer-spin-button,
        .no-spinner-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        .no-spinner-input[type=number] {
          -moz-appearance: textfield;
        }
      `}</style>
      
      {/* Input - WIDER */}
      <input
        type="number"
        min="0"
        value={value}
        readOnly={readOnly}
        onChange={(e) => {
          if (readOnly) return;
          const val = e.target.value;
          if (val === '' || val === '-') {
            onChange('');
          } else {
            const num = Number(val);
            if (!isNaN(num) && num >= 0) {
              onChange(num);
            }
          }
        }}
        placeholder="0"
        className={`no-spinner-input w-[65px] px-2 py-2 text-sm border border-gray-300 rounded-l-md 
                   focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200 appearance-none
                   ${readOnly ? 'bg-gray-50 cursor-not-allowed' : 'hover:border-blue-500'}`}
      />

      {/* Dropdown */}
      <select
        value={unit}
        disabled={readOnly}
        onChange={(e) => !readOnly && onUnitChange(e.target.value)}
        className={`w-[45px] px-1.5 py-1.5 text-sm border border-l-0 border-gray-300 
                   rounded-r-md bg-white text-gray-700 cursor-pointer
                   focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200
                   ${readOnly ? 'bg-gray-50 cursor-not-allowed' : 'hover:border-blue-500'}`}
      >
        {units.map((u) => (
          <option key={u.value} value={u.value}>
            {u.label}
          </option>
        ))}
      </select>
    </div>
  );
};



const ViewProductDetails = () => {
    const navigate= useNavigate();
    const [productCategories, setProductCategories] = useState([
      ]);
      const [products, setProducts] = useState([
      ]);
      const [productSubcategories, setProductSubcategories] = useState([
      ]);
   const location= useLocation();
   const { ItemData } = location.state || {};
  const [selectedProductCategory, setSelectedProductcategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  console.log(selectedProduct)
  const [productGroupid , setproductid] = useState(null);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const url = process.env.REACT_APP_FORE_BRICKBUCKET
  const [isLoading, setIsLoading] = useState(true);
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [vendor , setvendor] = useState()
  const [productCategory , setProductCategory] = useState()
  const [productGroup , setProductgroup] = useState()
   const [specifications, setSpecifications] = useState([]);
   const [productData, setproductData] = useState();
  const [showRequiredPopup, setShowRequiredPopup] = useState(false)
 // const [attributeLoading , setProductgrouploading]= useState(true)
  const [isSaving, setIsSaving] = useState(false);
  const [ProductLoader, setProductLoader] = useState(true)
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [imageSrc, setImageSrc] = useState('');
const [isUploading, setIsUploading] = useState(false);
const [roleId, setRoleId] = useState(null);
const [showQuantityPricingPopup, setShowQuantityPricingPopup] = useState(false);
const [quantityPricingRows, setQuantityPricingRows] = useState([
  { minQuantity: '', maxQuantity: '', sellingPrice: '', costPrice: '' }
]);
const [productMoqsData, setProductMoqsData] = useState({});
const [searches, setSearches] = useState([]);
const [assignType, setAssignType] = useState(null);
const assignDropdownRef = useRef(null);
const [showAssignPopup, setShowAssignPopup] = useState(false);
const [rows, setRows] = useState([{ SNo: '', Name: '', Value: ''}]);
const [showSpecificationsTable, setShowSpecificationsTable] = useState(false);
const [productActive, setProductActive] = useState(false);
const [discountError, setDiscountError] = useState('');
const [marginError, setMarginError] = useState('');
const [existingImages, setExistingImages] = useState([]);
const [newGalleryImages, setNewGalleryImages] = useState([]);
// 🔥 Add these states for pricing calculations
const [pricingData, setPricingData] = useState({
  mrp: '',
  discount: '',
  cost_price: '',
  margin_rate: '',
  selling_price: ''
});

const searchTypes = [
  'Item Name',
  'Vendors',
  'Item Category',
  'Item Sub Category',
  'Item Group',
];

const [searchQuery, setSearchQuery] = useState('');  
const [searchType, setSearchType] = useState('');  
const itemRefs = useRef({});
const listContainerRef = useRef(null);
const [showAssignAttributesPopup, setShowAssignAttributesPopup] = useState(false);
const [productAttributes, setAttributes] = useState([]);
const [attributeLoading, setAttributeLoading] = useState(false);
const [errors, setErrors] = useState({});
const [attributeIds, setAttributeIds] = useState([]);
const [Saving, setSaving] = useState(false);
const [searchChips, setSearchChips] = useState([]);
const [isEditMode, setIsEditMode] = useState(false);
const [editData, setEditData] = useState({});
// Add these states AFTER your existing state declarations
const [isPricingInvalid, setIsPricingInvalid] = useState(false);
const [marketRangeError, setMarketRangeError] = useState('');
const [quantityLimitsError, setQuantityLimitsError] = useState('');
const [productSubCategory, setProductSubCategory] = useState(null);
// Add these states for dropdown management in EDIT MODE
const [selectedProductCategoryDropdown, setSelectedProductCategoryDropdown] = useState(null);
const [selectedProductSubCategoryDropdown, setSelectedProductSubCategoryDropdown] = useState(null);
const [selectedVendorDropdown, setSelectedVendorDropdown] = useState(null);
const [selectedGroupDropdown, setSelectedGroupDropdown] = useState(null);
const [selectedUOMDropdown, setSelectedUOMDropdown] = useState(null);

// Add states for dropdown data
const [dropdownCategories, setDropdownCategories] = useState([]);
const [dropdownSubCategories, setDropdownSubCategories] = useState([]);
const [dropdownVendors, setDropdownVendors] = useState([]);
const [dropdownGroups, setDropdownGroups] = useState([]);
const [dropdownUOMs, setDropdownUOMs] = useState([]);
const [validationErrors, setValidationErrors] = useState({});
const [showValidationErrors, setShowValidationErrors] = useState(false);
const [currentGalleryIndex, setCurrentGalleryIndex] = useState(0);

const itemsToDisplay = useMemo(() => {
  let list = roleId === 6
    ? products.filter(
        item =>
          item.product_category_id?.product_category_name
            ?.toLowerCase() === 'tiles'
      )
    : products;

  // New: Simple single-filter logic instead of multi-search array
  if (searchQuery && searchType) {
    const q = searchQuery.toLowerCase();
    const type = searchType.toLowerCase();

    list = list.filter(item => {
      switch (type) {
        case 'item name':
          return item?.product_name?.toLowerCase().includes(q);
        case 'vendors':
          return item?.vendor_id?.name?.toLowerCase().includes(q);
        case 'item category':
          return item?.product_category_id?.product_category_name
            ?.toLowerCase()
            .includes(q);
        case 'item sub category':
          return item?.product_sub_category_id?.product_sub_category_name
            ?.toLowerCase()
            .includes(q);
        case 'item group':
          return item?.product_group_id?.product_group_name
            ?.toLowerCase()
            .includes(q);
        default:
          return true;
      }
    });
  }

  return list;
}, [products, searchQuery, searchType, roleId]);  

useEffect(() => {
  const savedQuery =
    sessionStorage.getItem('itemsSearchQuery') || '';

  const savedType =
    sessionStorage.getItem('itemsSearchType') || '';

  if (savedQuery && savedType) {
    setSearchQuery(savedQuery);
    setSearchType(savedType);
  }
}, []);



useEffect(() => {
  if (searchQuery && searchType) {
    const newChip = [{ query: searchQuery, type: searchType }];
    setSearchChips(newChip);

    sessionStorage.setItem('itemsSearchChips', JSON.stringify(newChip));
    sessionStorage.setItem('itemsSearchQuery', searchQuery);
    sessionStorage.setItem('itemsSearchType', searchType);
  } else {
    // ✅ CLEAR STORAGE WHEN EMPTY
    sessionStorage.removeItem('itemsSearchQuery');
    sessionStorage.removeItem('itemsSearchType');
    sessionStorage.removeItem('itemsSearchChips');
    setSearchChips([]);
  }
}, [searchQuery, searchType]);

const handleClearSearch = () => {
  setSearchQuery('');
  setSearchType('');
  setSearchChips([]);

  sessionStorage.removeItem('itemsSearchQuery');
  sessionStorage.removeItem('itemsSearchType');
  sessionStorage.removeItem('itemsSearchChips');
};

useAutoScroll({
  selectedItem: selectedProduct,
  itemRefs,
  containerRef: listContainerRef,
});

useEffect(() => {
  function handleClickOutside(event) {
    if (
      assignDropdownRef.current &&
      !assignDropdownRef.current.contains(event.target) &&
      !showAssignAttributesPopup // ✅ important condition
    ) {
      setAssignType(null);
    }
  }

  if (assignType && !showAssignAttributesPopup) {
    document.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [assignType, showAssignAttributesPopup]);


useEffect(() => {
    if (!selectedProduct) return;

    setExistingImages(selectedProduct.more_images || []);
}, [selectedProduct]);

useEffect(() => {
  if (existingImages.length <= 1) return;

  const interval = setInterval(() => {
    setCurrentGalleryIndex((prev) =>
      prev === existingImages.length - 1 ? 0 : prev + 1
    );
  }, 3000); // Change image every 3 seconds

  return () => clearInterval(interval);
}, [existingImages]);

const handleOpenAssign = () => {
  setAssignType(!assignType);
};

const handleAssignTypeSelect = (type) => {
  setAssignType(type);

  if (type === "attributes") {
    setShowAssignAttributesPopup(true);
    // 🔥 Clear errors and reset loading
    setErrors({});
    setAttributeLoading(true);
    // Fetch fresh attributes
    fetchAttributes(selectedProduct);
  }
};


// 🔥 EXACT SAME LOGIC AS EDITITEMS - PASTE THIS
const handlePricingChange = (field, value) => {
  setPricingData(prev => {
    let updated = { ...prev };

    const isPriceField = ["mrp", "discount", "cost_price", "margin_rate", "selling_price"].includes(field);

    if (!isPriceField) {
      updated[field] = value;
      return updated;
    }
 if (value === '' || value === null || value === undefined) {
      updated[field] = '';
      
      // 🔥 MRP CLEAR → ALL PRICING FIELDS CLEAR
      if (field === 'mrp') {
        updated.discount = '';
        updated.cost_price = '';
        updated.margin_rate = '';
        updated.selling_price = '';
        
        // 🔥 Sync ALL to editData
        setEditData(prevEdit => ({
          ...prevEdit,
          mrp: '',
          discount: '',
          cost_price: '',
          margin_rate: '',
          selling_price: ''
        }));
      } else {
        // 🔥 OTHER FIELDS → ONLY THAT FIELD CLEARS
        setEditData(prevEdit => ({
          ...prevEdit,
          [field]: ''
        }));
      }
      
      setIsPricingInvalid(false);
      return updated;
    }

  const numericValue = value === "" ? "" : Number(value);
    updated[field] = numericValue;

    // 🔥 NEW VALIDATION LOGIC
    if (field === "discount") {
      if (numericValue > 100) {
        setDiscountError("Discount cannot exceed 100%");
      } else {
        setDiscountError("");
      }
    }

    if (field === "margin_rate") {
      if (numericValue > 100) {
        setMarginError("Margin cannot exceed 100%");
      } else {
        setMarginError("");
      }
    }


    // Extract values safely
    const mrp = Number(updated.mrp);
    const discount = Number(updated.discount);
    const cost = Number(updated.cost_price);
    const margin = Number(updated.margin_rate);
    const selling = Number(updated.selling_price);

    const hasValidMRP = !isNaN(mrp) && mrp > 0;
    const hasValidDiscount = !isNaN(discount) && discount >= 0 && discount <= 100;
    const hasValidCost = !isNaN(cost) && cost > 0;
    const hasValidMargin = !isNaN(margin) && margin >= 0;
    const hasValidSelling = !isNaN(selling) && selling >= 0;

    // CASE 1 — MRP or Discount updated
    if (field === "mrp" || field === "discount") {
      if (hasValidMRP && hasValidDiscount) {
        updated.cost_price = Number((mrp * (1 - discount / 100)).toFixed(2));
        const newCost = Number(updated.cost_price);
        if (hasValidMargin && newCost > 0) {
          updated.selling_price = Number((newCost * (1 + margin / 100)).toFixed(2));
        }
      }
    }

    // CASE 2 — Cost Price updated
    if (field === "cost_price") {
      if (hasValidMRP && hasValidCost) {
        updated.discount = Number((((mrp - cost) / mrp) * 100).toFixed(2));
        if (updated.discount < 0) updated.discount = 0;
        if (updated.discount > 100) updated.discount = 100;
      }
      if (hasValidCost && hasValidMargin) {
        updated.selling_price = Number((cost * (1 + margin / 100)).toFixed(2));
      } else if (hasValidCost && hasValidSelling) {
        updated.margin_rate = Number((((selling - cost) / cost) * 100).toFixed(2));
      }
    }

    // CASE 3 — Margin updated
    if (field === "margin_rate" && hasValidCost && hasValidMargin) {
      updated.selling_price = Number((cost * (1 + margin / 100)).toFixed(2));
    }

    // CASE 4 — Selling Price updated
    if (field === "selling_price" && hasValidCost && hasValidSelling) {
      updated.margin_rate = Number((((selling - cost) / cost) * 100).toFixed(2));
    }

    // Safety check
    Object.keys(updated).forEach(key => {
      if (isNaN(updated[key])) updated[key] = "";
    });

    // 🔥 UPDATE PRICING VALIDATION
    const isInvalid = 
      Number(updated.cost_price) > 0 &&
      Number(updated.selling_price) > 0 &&
      Number(updated.cost_price) > Number(updated.selling_price);
    setIsPricingInvalid(isInvalid);

    // 🔥 FIXED: Sync ALL calculated fields to editData using UPDATED values
    setEditData(prevEdit => ({
      ...prevEdit,
      mrp: updated.mrp,
      discount: updated.discount,
      cost_price: updated.cost_price,
      margin_rate: updated.margin_rate,  // ✅ NOW CORRECT
      selling_price: updated.selling_price
    }));

    return updated;
  });
};


const fetchDropdownCategories = async () => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);
    const response = await fetch(`${backendApiUrl}product-category/get-all-productCategories`, {
      headers: { "Content-Type": "application/json", "x-token": token }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      const categories = data.data.map(cat => ({
        value: cat._id,
        label: cat.product_category_name
      }));
      setDropdownCategories(categories);
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};

// Fetch UOMs for Dropdown
const fetchDropdownUOMs = async () => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);
    const response = await fetch(`${backendApiUrl}UOMs/get-all-UOMs`, {
      headers: { "Content-Type": "application/json", "x-token": token }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      const uoms = data.data.map(uom => ({
        value: uom._id,
        label: uom.UOM
      }));
      setDropdownUOMs(uoms);
    }
  } catch (error) {
    console.error("Error fetching UOMs:", error);
  }
};

// 🔥 ADD THESE 4 FUNCTIONS
const fetchDropdownSubCategories = async (product_category_id, attempt = 1) => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);
    
    const response = await fetch(
      `${backendApiUrl}product-sub-category/get-product-subCategories-and-vendors-by-productCategory?product_category_id=${product_category_id}`, 
      {
        method: 'GET',
        headers: { 
          "Content-Type": "application/json", 
          "x-token": token 
        }
      }
    );
    
    const data = await response.json();
    
    if (data.status === 200 || data.status === 201) {
      // Transform subcategories for dropdown
      const subcategories = data.data.subCategories.map(sub => ({
        value: sub._id,
        label: sub.product_sub_category_name
      }));
      setDropdownSubCategories(subcategories);
      
      // Transform vendors for dropdown (bonus from same API)
      const vendors = data.data.AllAssignedVendors.map(vendor => ({
        value: vendor._id,
        label: vendor.vendor_name
      }));
      setDropdownVendors(vendors);
      
    } else {
      setDropdownSubCategories([]);
      setDropdownVendors([]);
    }
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    setDropdownSubCategories([]);
    setDropdownVendors([]);
  }
};

const fetchDropdownVendors = async () => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);
    const encryptedhubId = sessionStorage.getItem('hubId');
    const hubId = decryptData(encryptedhubId);
    
    const response = await fetch(`${backendApiUrl}vendors/get-all-vendors?hubId=${hubId}`, {
      headers: { "Content-Type": "application/json", "x-token": token }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      const vendors = data.data.map(vendor => ({
        value: vendor._id,
        label: vendor.vendor_name || vendor.name
      }));
      setDropdownVendors(vendors);
    }
  } catch (error) {
    console.error("Error fetching vendors:", error);
  }
};

const fetchDropdownGroups = async (product_category_id = null, vendor_id = null) => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);
    
    // Use provided IDs or fallback to selected product data
    const categoryId = product_category_id || selectedProductCategoryDropdown?.value || selectedProduct?.product_category_id?._id;
    const vendorId = vendor_id || selectedVendorDropdown?.value || selectedProduct?.vendor_id?._id;
    
    // Only fetch if we have both category and vendor
    if (!categoryId || !vendorId) {
      setDropdownGroups([]);
      return;
    }
    
    const response = await fetch(
      `${backendApiUrl}product-groups/get-productGroups-by-vendor-and-productCategory?product_category_id=${categoryId}&&vendor_id=${vendorId}`,
      {
        headers: { "Content-Type": "application/json", "x-token": token }
      }
    );
    
    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      const groups = data.data.map(group => ({
        value: group._id,
        label: group.product_group_name
      }));
      setDropdownGroups(groups);
    } else {
      setDropdownGroups([]);
    }
  } catch (error) {
    console.error("Error fetching filtered groups:", error);
    setDropdownGroups([]);
  }
};

const fetchAttributes = async (product) => {
  const categoryId = product?.product_category_id?._id || selectedProduct?.product_category_id?._id;
  const subCategoryId = product?.product_sub_category_id?._id || selectedProduct?.product_sub_category_id?._id || null;
  const groupId = product?.product_group_id?._id || selectedProduct?.product_group_id?._id || null;
  const id = product?._id || selectedProduct?._id || null;
  
  try {
    setAttributeLoading(true);

    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${backendApiUrl}product-attributes/get-attr-upward?product_category_id=${categoryId}&product_sub_category_id=${subCategoryId}&product_group_id=${groupId}&product_id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const apiResponse = await response.json();
    console.log('API RESPONSE:', apiResponse);

    const status = apiResponse.status || response.status;
    const attributesData = apiResponse.data || apiResponse || [];

    if (status === 200 || status === 201 || status === 204) {
      let fetchedAttributes = Array.isArray(attributesData) ? attributesData : [];

      fetchedAttributes.sort((a, b) => a.attribute_name.localeCompare(b.attribute_name));

      fetchedAttributes.forEach(attr => {
        if (attr?.attribute_values && Array.isArray(attr.attribute_values)) {
          attr.attribute_values.sort((a, b) => 
            a.attribute_value.localeCompare(b.attribute_value)
          );
        }
      });

      console.log("SORTED ATTRIBUTES:", fetchedAttributes);
      setAttributes(fetchedAttributes);

      const preSelectedIds = [];
      if (selectedProduct?.filterable_attributes && Array.isArray(selectedProduct.filterable_attributes)) {
        selectedProduct.filterable_attributes.forEach(attr => {
          const valueId = attr.attribute_value_id;
          
          for (const fetchedAttr of fetchedAttributes) {
            const matchingValue = fetchedAttr.attribute_values?.find(val => 
              val.attribute_value_id === valueId
            );
            
            if (matchingValue) {
              preSelectedIds.push({
                attribute_name_id: fetchedAttr.attribute_name_id,
                attribute_value_id: valueId
              });
              break;
            }
          }
        });
      }
      
      const uniquePreSelected = preSelectedIds.filter((item, index, self) => 
        index === self.findIndex(t => t.attribute_value_id === item.attribute_value_id)
      );
      
      setAttributeIds(uniquePreSelected);
    } else {
      console.log('API ERROR - Status:', status);
      setAttributes([]);
      setAttributeIds([]);
    }
  } catch (error) {
    console.error("Error fetching attributes:", error);
    setAttributes([]);
    setAttributeIds([]);
  } finally {
    setAttributeLoading(false);
  }
};

const handleCloseAttributePopup = () => {
  setShowAssignAttributesPopup(false);
  setAssignType(null);  
  setErrors({});
  setAttributeIds([]);  
};

useEffect(() => {
  fetchRoleId();
  fetchItems(ItemData);
  
  // 🔥 ONLY fetch categories initially
  fetchDropdownCategories();
  fetchDropdownUOMs();
  
  // 🔥 Populate dropdown states when ItemData is available
  if (ItemData) {
    // Category
    if (ItemData.product_category_id?._id) {
      setSelectedProductCategoryDropdown({
        value: ItemData.product_category_id._id,
        label: ItemData.product_category_id.product_category_name
      });
      setProductCategory(ItemData.product_category_id);
      
      // 🔥 Fetch subcategories + vendors
      fetchDropdownSubCategories(ItemData.product_category_id._id);
    }
    
    // Subcategory
    if (ItemData.product_sub_category_id?._id) {
      setSelectedProductSubCategoryDropdown({
        value: ItemData.product_sub_category_id._id,
        label: ItemData.product_sub_category_id.product_sub_category_name
      });
      setProductSubCategory(ItemData.product_sub_category_id);
    }
    
    // Vendor
    if (ItemData.vendor_id?._id) {
      setSelectedVendorDropdown({
        value: ItemData.vendor_id._id,
        label: ItemData.vendor_id.name || ItemData.vendor_id.vendor_name
      });
      setvendor(ItemData.vendor_id);
    }
    
    // Product Group
    if (ItemData.product_group_id?._id) {
      setSelectedGroupDropdown({
        value: ItemData.product_group_id._id,
        label: ItemData.product_group_id.product_group_name
      });
      setProductgroup(ItemData.product_group_id);
    }
    
    // UOM
    if (ItemData.UOM_id?._id) {
      setSelectedUOMDropdown({
        value: ItemData.UOM_id._id,
        label: ItemData.UOM_id.UOM
      });
    }
    
    setImageSrc(imageUrl + ItemData.product_image);
  }
}, [ItemData]);


useEffect(() => {
  if (selectedProductCategoryDropdown?.value) {
    fetchDropdownSubCategories(selectedProductCategoryDropdown.value);
    setSelectedProductSubCategoryDropdown(null);
    setSelectedGroupDropdown(null);
    setDropdownGroups([]);
  }
}, [selectedProductCategoryDropdown]);

useEffect(() => {
  if (selectedProductCategoryDropdown?.value && selectedVendorDropdown?.value) {
    fetchDropdownGroups(selectedProductCategoryDropdown.value, selectedVendorDropdown.value);
  } else {
    setDropdownGroups([]);
    setSelectedGroupDropdown(null);
  }
}, [selectedVendorDropdown, selectedProductCategoryDropdown]);

const handleRadioChange = (attribute_name_id, attribute_value_id) => {
  setAttributeIds((prev) => {
    const isSelected = prev.some(attr => attr.attribute_value_id === attribute_value_id);
    let newState;
    
    if (isSelected) {
      newState = prev.filter(attr => attr.attribute_value_id !== attribute_value_id);
    } else {
      const filtered = prev.filter(attr => attr.attribute_name_id !== attribute_name_id);
      newState = [...filtered, { attribute_name_id, attribute_value_id }];
    }
    return newState;
  });
};
   
const handleAddattributesToItem = async () => {


  console.log(attributeIds)

  if (attributeIds.length === 0) {
    setErrors({ assign_attribute: "Please select attribute values" });
    return;
  }

  try {

    setIsSaving(true);

    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${backendApiUrl}product/assign-attributes-to-product`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          product_id: selectedProduct._id,
          attributes: attributeIds,
        }),
      }
    );

    const data = await response.json();
    console.log('Assign attributes response:', data);

       if (data.status === 200 || data.status === 201) {
            setShowAssignAttributesPopup(false);
            setAssignType(false);  
   setShowPopup(true);
        setPopupType('200or201');
        setPopupMessage("Attribute values assigned successfully.");

  setTimeout(async () => {
        await fetchItems(selectedProduct);
        
        await getProductDetails(selectedProduct._id);
        
        setAttributeIds([]);
        
        setShowPopup(false);
      }, 1000);
}
    

  } catch (error) {
    console.error("Error assigning attributes:", error);
  } finally {
    setSaving(false);
  }
};

/* useEffect(() => {
  if (selectedProduct && selectedProduct.product_image) {
    setImageSrc(imageUrl + selectedProduct.product_image);
  }
}, [selectedProduct, imageUrl]); */


/* const handleImageChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('image', file); // This should match the field name in Multer's configuration
    formData.append('_id', selectedProduct._id);

    setIsUploading(true);

    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/change-product-image`, {
        method: 'PUT',
        headers: {
          'x-token': token,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === 200) {

        setImageSrc(imageUrl + data.data.product_image); // Update the image URL with the new uploaded image URL
        fetchItems(data.data)
      } else {
        console.error('Failed to upload image:', data.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setIsUploading(false);
    }
  }
}; */




const handleImageChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('image', file); // This should match the field name in Multer's configuration
    formData.append('_id', selectedProduct._id);

    setIsUploading(true);

    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/change-product-image`, {
        method: 'PUT',
        headers: {
          'x-token': token,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === 200) {

        setImageSrc(imageUrl + data.data.product_image); // Update the image URL with the new uploaded image URL
        fetchItems(data.data)
      } else {
        console.error('Failed to upload image:', data.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setIsUploading(false);
    }
  }
};

const handleDragOver = (e) => {
  e.preventDefault();
  e.stopPropagation();
  // Optional: Add visual feedback for drag over
  e.currentTarget.classList.add('border-blue-500', 'bg-blue-50');
};

const handleDragLeave = (e) => {
  e.preventDefault();
  e.stopPropagation();
  // Remove visual feedback
  e.currentTarget.classList.remove('border-blue-500', 'bg-blue-50');
};

const handleDrop = async (e) => {
  e.preventDefault();
  e.stopPropagation();
  
  // Remove visual feedback
  e.currentTarget.classList.remove('border-blue-500', 'bg-blue-50');
  
  const files = e.dataTransfer.files;
  if (files.length > 0) {
    const file = files[0];
    
    // Check if it's an image file
    if (file.type.startsWith('image/')) {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('_id', selectedProduct._id);

      setIsUploading(true);

      try {
            const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/change-product-image`, {
          method: 'PUT',
          headers: {
            'x-token': token,
          },
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 200) {
          setImageSrc(imageUrl + data.data.product_image);
          fetchItems(data.data);
        } else {
          console.error('Failed to upload image:', data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      } finally {
        setIsUploading(false);
      }
    } else {
      // Optional: Show error message for non-image files
      alert('Please select an image file');
    }
  }
};


const handleFileInputClick = () => {
  document.getElementById('imageInput').click();
};

/*   useEffect(() => {
    const fetchProductCategories = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(url + "product-category/get-all-productCategories", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token':token
                }
            });
            const data = await response.json();
            if (response.ok) {
                setProductCategories(data); // Update customers state
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error(error);
        }
    }
    fetchProductCategories();
}, []); */

/* useEffect(() => {
    const fetchItems = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "product-groups/get-all-products", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token':token
                }
            });
            const data = await response.json();
            if (response.ok) {
                setProducts(data); // Update ItemGroups state
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error(error);
        }finally {
          setIsLoading(false);
        }
    }
    fetchItems();
}, []); */

// useEffect(() => {
//   fetchRoleId();
//   fetchItems(ItemData);
//   //setImageSrc(imageUrl + ItemData.product_image)
// }, [ItemData]);



const fetchRoleId = () => {
  const encryptedroleId = sessionStorage.getItem('roleId');
  const sroleId = decryptData(encryptedroleId);
  setRoleId(sroleId);
};

const fetchItems = async (selectedItem,attempt = 1) => {
  try {
       const encryptedToken = sessionStorage.getItem('token');
           const token = decryptData(encryptedToken);
           const encryptedhubId = sessionStorage.getItem('hubId');
           const hubId = decryptData(encryptedhubId);
    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `product/get-all-products?hubId=${hubId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    console.log(data)
    if (data.status === 200 || data.status === 201 || data.status === 204) {
      setProducts(data.data);

      const findLatestItem = data.data.find(p => 
        p && p._id && selectedItem && selectedItem._id 
        ? p._id === selectedItem._id 
        : false
      );
  
      // Conditional updates with fallback
      if (findLatestItem) {
        setSelectedProduct(findLatestItem);

        handleProductClick(findLatestItem);
      } else {
         setSelectedProduct(selectedItem);
          handleProductClick(selectedItem);
      }
    } else if (data.status === 400) {
      setShowPopup(true);
      setPopupType('400');
      setPopupMessage('Bad Request!');
    } else if (data.status === 401) {
      setShowPopup(true);
      setPopupType('401');
      setPopupMessage('Unauthorized!');
    } else if (data.status === 403) {
      setShowPopup(true);
      setPopupType('403');
      setPopupMessage('Forbidden!');
    } else if (data.status === 404) {
      setShowPopup(true);
      setPopupType('404');
      setPopupMessage('Not Found!');
    } else if (data.status === 500) {
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error!');
    } else {
      setShowPopup(true);
      setPopupType('unknown');
      setPopupMessage('Unknown error!');
    }
  } catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1); // Increment retry count
      setTimeout(() => fetchItems(selectedItem,attempt + 1), 1000); // Retry after 1 second
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => fetchItems(selectedItem,attempt)); // Set retry function
    }
  } finally {
    setIsLoading(false);
  }
};

  const handleProductClick = (product) => {
  if (!product || !product._id) {
    console.error("Invalid product or product ID");
    return;
  }
  
  // 🔥 CRITICAL FIX: EXIT EDIT MODE WHEN SELECTING NEW ITEM
  if (isEditMode) {
    setIsEditMode(false);
    setEditData({});
    setIsPricingInvalid(false);
    setMarketRangeError('');
    setQuantityLimitsError('');
  }
  
  setproductid(product._id);
  setSelectedProduct(product);
  getProductDetails(product._id);
  setProductLoader(true);
  setImageSrc(imageUrl + product?.product_image);
  
  // 🔥 RESET DROPDOWN STATES when switching items
  setSelectedProductCategoryDropdown(null);
  setSelectedProductSubCategoryDropdown(null);
  setSelectedVendorDropdown(null);
  setSelectedGroupDropdown(null);
  setSelectedUOMDropdown(null);
  
  fetchAttributes(product);
};

  const getProductDetails = async (id, attempt = 1) => {
    if (!id) {
      console.error("Invalid product ID");
      return;
    }
  
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const apiEndpoint = backendApiUrl + `product/get-product?id=${id}`; // Replace with your actual API endpoint
  
      // Make a GET request to the API
      const response = await fetch(apiEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
      });
  
      const data = await response.json();
      console.log('Product details response:', data);
      const output = await getResponseHandling(response, data);
      if (output) {
        setProductgroup(output?.productGroup);
        setproductData(output?.productData || []);
        setProductSubCategory(output?.productSubCategory);
  
       // 🔥 COMPLETE SPECIFICATIONS PARSING - REPLACE ENTIRE SECTION
const specifications = output?.productData?.specifications;

let parsedSpecifications = [];
let parsedRows = []; // 🔥 NEW

if (typeof specifications === 'string' && specifications.trim() !== "") {
  try {
    const parsedData = JSON.parse(specifications);
    
    if (Array.isArray(parsedData)) {
      parsedSpecifications = parsedData.filter(spec => {
        if (typeof spec === 'object' && spec !== null) {
          return Object.entries(spec).some(([key, value]) => 
            value !== null && 
            value !== undefined && 
            value !== ""
          );
        }
        return false;
      });

      // 🔥 NEW: Parse into ROWS format for table
      parsedRows = parsedData.map((spec, index) => {
        const firstKey = Object.keys(spec)[0];
        const firstValue = Object.values(spec)[0];
        return {
          SNo: index + 1,
          Name: firstKey || '',
          Value: firstValue || ''
        };
      }).filter(row => row.Name.trim() !== '' && row.Value.trim() !== '');
      
    } else if (typeof parsedData === 'object' && parsedData !== null) {
      const filteredSpec = Object.fromEntries(
        Object.entries(parsedData).filter(([key, value]) => 
          value !== null && 
          value !== undefined && 
          value !== ""
        )
      );
      
      if (Object.keys(filteredSpec).length > 0) {
        parsedSpecifications = [filteredSpec];
        
        // 🔥 NEW: Single row format
        parsedRows = [{
          SNo: 1,
          Name: Object.keys(filteredSpec)[0] || '',
          Value: Object.values(filteredSpec)[0] || ''
        }];
      }
    }
  } catch (error) {
    console.error("Error parsing specifications:", error);
  }
} else {
  parsedRows = [];
}

// 🔥 UPDATE BOTH STATES
setSpecifications(parsedSpecifications);
setRows(parsedRows);
setShowSpecificationsTable(parsedRows.length > 0); // 🔥 Show table if rows exist
        setvendor(output?.vendor);
        setProductCategory(output?.productCategory);
      } else {
        setProductgroup();
        setvendor();
        setProductCategory();
        setproductData([]);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => getProductDetails(id, attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => getProductDetails(id, attempt)); // Set retry function
      }
    } finally {
      setProductLoader(false);
    }
  };

  const saveQuantityPricing = async () => {
    //console.log(quantityPricingRows)
    try {
      const InputData = {
        product_category_id: selectedProduct?.product_category_id?._id || null,
        product_sub_category_id: selectedProduct?.product_sub_category_id?._id || null,
        product_group_id: selectedProduct?.product_group_id?._id || null,
        product_id: selectedProduct?._id || null,
        moq_for_item_type : 'Product',
        moqs: quantityPricingRows.map(row => ({
          min_quantity: Number(row.minQuantity) || 0,
          max_quantity: Number(row.maxQuantity) || 0,
          selling_price: Number(row.sellingPrice) || 0,
          cost_price: Number(row.costPrice) || 0
        }))
      };
      console.log(backendApiUrl)
         const encryptedToken = sessionStorage.getItem('token');
             const token = decryptData(encryptedToken);

      console.log('token', token)
      const response = await fetch(backendApiUrl + 'moqs/create-update-moq', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(InputData)
      });
      console.log(response)
      const data = await response.json();
      
      if (response.ok) {
        setShowPopup(true);
        setPopupType('200or201');
        setPopupMessage('MOQs saved successfully');
        setTimeout(() => {
          setPopupType(false)
          setPopupMessage('');
        }, 2000);
        setShowQuantityPricingPopup(false);
      } else {
        setShowPopup(true);
        setPopupType('400');
        setPopupMessage(data.message || 'Failed to save MOQs');
      }
    } catch (error) {
      console.error('Error saving MOQs:', error);
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error. Please try again.');
    }
  };
  

  
  const getResponseHandling = async (response, data)=>{
    if (response.ok) {
      if (response.status === 200 || response.status === 201) {
        setPopupType('200or201');
          return (data.data)
      } else if (response.status === 204) {
        setPopupType('204');
        return (data.data)
      } 
    } else {
      if (response.status === 400) {
        setPopupType('400');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 401) {
        setPopupType('401');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 403) {
       
        setPopupType('403');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 500) {
       
        setPopupType('500');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else {
        setErrorMessages([...errorMessages, data.message]);
      }
    }
  }
const handleClose = () => {
  navigate(-1);
};

   const handleClosePopup = ()=>{
    setShowRequiredPopup(false);
   }
  
   const HandleMoqs = async () =>{
    await getMOQsByProductGroupId(selectedProduct._id)
    setShowQuantityPricingPopup(true)
   }

   const getMOQsByProductGroupId = async (productId) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}moqs/get-moq-by-product-id?product_id=${productId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      });
      const data = await response.json();
      console.log(data)
      if (data.status === 200) {
        setProductMoqsData(data.data);
        const MoqsData = data.data;
        const MoqsDataArray = Array.isArray(MoqsData.moqs) ? MoqsData.moqs.map(item => ({
          minQuantity : item.min_quantity,
          maxQuantity : item.max_quantity,
          sellingPrice: item.selling_price,
          costPrice: item.cost_price
        })) : [];
        console.log(MoqsDataArray)
        setQuantityPricingRows(MoqsDataArray || []);
      } else {
        setQuantityPricingRows([])
        console.error("Failed to fetch MOQs:", data.message);
      }
    } catch (error) {
      console.error("Error fetching MOQs:", error);
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  
  const Retry = async() => {
    setTimeout(async ()=>{
      if(retryFunction){

        await retryFunction ();
      }

      setIsLoading(false)
    },1000)
    
    setShowPopup(false);
  };

  const handleDeleteItemImage = async (selectedItem) => {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

  
    // Validate if necessary data is available
    if (!token) {
      console.error("Missing token or hubId. Unable to proceed.");
      return;
    }
  
    try {
      // Construct the API URL with query parameters
      const url = new URL(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/delete-product-image`);
  
      const itemdata = {
        _id: selectedItem._id,
        product_image: ''
      };
  
      // Make the API call
      const response = await fetch(url.toString(), {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          "x-token": token,
        },
        body: JSON.stringify(itemdata)
      });
  
      // Check response status before parsing
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error:", errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      // Parse the response
      const data = await response.json();
  
      // Check if the status is successful
      if (data.status === 200) {
        handleUpdateTheImageDataInItem(selectedItem);
      } else {
        console.error("Failed to delete image:", data.message || "Unknown error.");
      }
    } catch (error) {
      // Catch any network or unexpected errors
      console.error("Error while deleting image:", error.message);
    }
  };
  
  
  const handleUpdateTheImageDataInItem = (selectedItem) => {
    try {
      // Validate input
      if (!selectedItem || !selectedItem._id) {
        console.error('Invalid item: Missing _id');
        return;
      }
  
      // Create a new item object with updated image
      const updatedItem = {
        ...selectedItem,
        product_image: ""
      };
  
      // Update the selected product state
      setSelectedProduct((prevProduct) => {
        // Ensure we're updating the correct product
        if (prevProduct?._id !== selectedItem._id) {
          console.warn('Attempted to update a different product');
          return prevProduct;
        }
        
        return {
          ...prevProduct,
          product_image: ""
        };
      });
  
      // Fetch items with error handling
      const fetchItemsWithErrorHandling = async () => {
        try {
          await fetchItems(updatedItem);
        } catch (fetchError) {
          console.error('Error fetching items after image deletion:', fetchError);
          // Optional: Show user-friendly error notification
          // setErrorMessage('Failed to update item. Please try again.');
        }
      };
  
      // Call the fetch function
      fetchItemsWithErrorHandling();
  
    } catch (error) {
      console.error('Comprehensive error in handleUpdateTheImageDataInItem:', {
        message: error.message,
        stack: error.stack,
        item: selectedItem
      });
  
      // Optional: Implement error tracking or reporting
      // errorTrackingService.report(error);
    }
  };
  
  

  const BackToLoginPage = () => {
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
    };

    // Add this function to handle input changes in the quantity pricing table
const handleQuantityPricingChange = (index, field, value) => {
  const updatedRows = [...quantityPricingRows];
  updatedRows[index][field] = value;
  setQuantityPricingRows(updatedRows);
};

// Add this function to add a new row to the quantity pricing table
const addQuantityPricingRow = () => {
  setQuantityPricingRows([
    ...quantityPricingRows, 
    { minQuantity: '', maxQuantity: '', sellingPrice: '', costPrice: '' }
  ]);
};

// Add this function to delete a row from the quantity pricing table
const deleteQuantityPricingRow = (index) => {
  const updatedRows = [...quantityPricingRows];
  updatedRows.splice(index, 1);
  setQuantityPricingRows(updatedRows);
};

// Add this function to save the quantity pricing data
/* const saveQuantityPricing = () => {
  
  setShowQuantityPricingPopup(false);
}; */


    const closePopup = () => {
      setShowPopup(false);
    };

    const handleCreateItem = () => {
      navigate('/bb/app/items/newitem');
    }

    // const handleEditItem = () => {
    //   navigate('/bb/app/items/edititems', { state: { ItemData: selectedProduct } });
    // }



const handleSearch = ({ query, type }) => {
  if (!query?.trim() || !type) return;
  setSearchQuery(query.trim());
  setSearchType(type);
};

const handleCancelEdit = () => {
  setIsEditMode(false);
  
  // 🔥 RESET PRICING DATA
  setPricingData({
    mrp: '',
    discount: '',
    cost_price: '',
    margin_rate: '',
    selling_price: ''
  });
  
  // 🔥 Reset validation
  setIsPricingInvalid(false);
  setMarketRangeError('');
  setQuantityLimitsError('');
  
  // 🔥 Refresh original data
  const refreshOriginalData = async () => {
    try {
      setProductLoader(true);
      await getProductDetails(selectedProduct._id);
      await fetchItems(selectedProduct);
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setProductLoader(false);
    }
  };
  
  refreshOriginalData();
  setEditData({});
};

const handleEditItem = () => {
  setIsEditMode(true);
  
  // 🔥 STEP 1: Calculate margin from existing data FIRST
  const cost = parseFloat(selectedProduct?.cost_price) || 0;
  const selling = parseFloat(selectedProduct?.selling_price) || 0;
  const marginPercent = selectedProduct?.margin_rate || '';

  // let marginPercent = '';
  // if (cost > 0 && selling > 0) {
  //   marginPercent = Number(((selling - cost) / cost * 100).toFixed(2));
  // }
  
  // 🔥 STEP 2: Initialize PRICING DATA with REAL VALUES
  const pricingInit = {
    mrp: selectedProduct?.mrp || '',
    discount: selectedProduct?.discount || '',
    cost_price: selectedProduct?.cost_price || '',
    margin_rate: selectedProduct?.margin_rate || '',  // 🔥 CALCULATED
    selling_price: selectedProduct?.selling_price || ''
  };
  
  setPricingData(pricingInit);  // 🔥 SET PRICING DATA FIRST
  
  // 🔥 STEP 3: Set editData
  setEditData({
    product_name: selectedProduct?.product_name || '',
    SKU: selectedProduct?.SKU || '',
    HSN_Code: selectedProduct?.HSN_Code || '',
    UOM: selectedProduct?.UOM || selectedProduct?.UOM_id?.UOM || '',
    purchase_mode: selectedProduct?.purchase_mode || '',
    quote_threshold_quantity: selectedProduct?.quote_threshold_quantity || '',
    tax_preference: selectedProduct?.tax_preference || '',
    GST: selectedProduct?.GST || '',
    IGST: selectedProduct?.IGST || '',
    mrp: selectedProduct?.mrp || '',
    discount: selectedProduct?.discount || '',
    cost_price: selectedProduct?.cost_price || '',
    margin_rate: pricingInit.margin_rate,  // 🔥 SAME CALCULATED VALUE
    selling_price: selectedProduct?.selling_price || '',
    market_range: {
      min: selectedProduct?.market_range?.min || '',
      max: selectedProduct?.market_range?.max || ''
    },
    quantity_limits: {
      min: selectedProduct?.quantity_limits?.min || '',
      max: selectedProduct?.quantity_limits?.max || ''
    },
    weight: {
      value: selectedProduct?.weight?.value || '',
      unit: selectedProduct?.weight?.unit || 'kg'
    },
    dimensions: {
      length: selectedProduct?.dimensions?.length || '',
      width: selectedProduct?.dimensions?.width || '',
      height: selectedProduct?.dimensions?.height || '',
      unit: selectedProduct?.dimensions?.unit || 'cm'
    },
    product_description: selectedProduct?.product_description || '',
    alternate_names: Array.isArray(selectedProduct?.alternate_names) 
      ? selectedProduct.alternate_names.join(', ') 
      : selectedProduct?.alternate_names || '',
    is_delivered_by_brickbucket: selectedProduct?.is_delivered_by_brickbucket || false,
    is_COD_available: selectedProduct?.is_COD_available || false,
    tax_included: selectedProduct?.tax_included || false,
     is_active: selectedProduct?.is_active ?? true,
    is_buildcoins_applicable: selectedProduct?.is_buildcoins_applicable || false,
    buildcoins_max_quantity_applicable: selectedProduct?.buildcoins_max_quantity_applicable || '',
    buildcoins_max_discount: selectedProduct?.buildcoins_max_discount || ''
  });

  // 🔥 STEP 4: Initialize dropdown states (your existing code)
  if (selectedProduct) {
    if (selectedProduct.product_category_id?._id) {
      setSelectedProductCategoryDropdown({
        value: selectedProduct.product_category_id._id,
        label: selectedProduct.product_category_id.product_category_name
      });
    }
    if (selectedProduct.product_sub_category_id?._id) {
      setSelectedProductSubCategoryDropdown({
        value: selectedProduct.product_sub_category_id._id,
        label: selectedProduct.product_sub_category_id.product_sub_category_name
      });
    }
    if (selectedProduct.vendor_id?._id) {
      setSelectedVendorDropdown({
        value: selectedProduct.vendor_id._id,
        label: selectedProduct.vendor_id.name || selectedProduct.vendor_id.vendor_name
      });
    }
    if (selectedProduct.product_group_id?._id) {
      setSelectedGroupDropdown({
        value: selectedProduct.product_group_id._id,
        label: selectedProduct.product_group_id.product_group_name
      });
    }
    if (selectedProduct.UOM_id?._id) {
      setSelectedUOMDropdown({
        value: selectedProduct.UOM_id._id,
        label: selectedProduct.UOM_id.UOM
      });
    }
  }
};

const validateRequiredFields = () => {
  const errors = {};
  
  // ✅ EXISTING VALUES = NO ERROR (for editing)
  const hasCategory = selectedProductCategoryDropdown?.value || selectedProduct?.product_category_id?._id;
  const hasVendor = selectedVendorDropdown?.value || selectedProduct?.vendor_id?._id;
  const hasUOM = selectedUOMDropdown?.value || selectedProduct?.UOM_id?._id;
  
  // 🔥 REQUIRED FIELDS - Only if NOT already set
  if (!hasCategory) {
    errors['Item Category'] = 'Item Category *** is required';
  }
  
  if (!hasVendor) {
    errors['Vendor Name'] = 'Vendor Name *** is required';
  }
  
  if (!editData.product_name?.trim()) {
    errors['Product Name'] = 'Product Name *** is required';
  }
  
  if (!hasUOM) {
    errors['UOM'] = 'UOM *** is required';
  }
  
  if (!editData.tax_preference?.trim()) {
    errors['Tax Preference'] = 'Tax Preference *** is required';
  }
  
  if (!editData.purchase_mode?.trim()) {
    errors['Purchase Mode'] = 'Purchase Mode *** is required';
  }
  
  // 🔥 CONDITIONAL - Only if Purchase Mode = "Both"
  if (editData.purchase_mode === 'Both' && !editData.quote_threshold_quantity?.trim()) {
    errors['Eligible Qty'] = 'Eligible Qty *** is required for "Both" mode';
  }
  
  // 🔥 PRICING - Always required
  if (!editData.mrp?.trim()) {
    errors['MRP'] = 'MRP *** is required';
  }
  
  if (!editData.cost_price?.trim()) {
    errors['Cost Price'] = 'Cost Price *** is required';
  }
  
  if (!editData.selling_price?.trim()) {
    errors['Selling Price'] = 'Selling Price *** is required';
  }
  
  // 🔥 MARKET RANGE
  if (!editData.market_range?.min?.trim()) {
    errors['Market Range Min'] = 'Market Range Min *** is required';
  }
  
  if (!editData.market_range?.max?.trim()) {
    errors['Market Range Max'] = 'Market Range Max *** is required';
  }
  
  // 🔥 MARKET RANGE LOGIC - Min < Max
  const minMarket = parseFloat(editData.market_range?.min) || 0;
  const maxMarket = parseFloat(editData.market_range?.max) || 0;
  if (minMarket >= maxMarket && (minMarket > 0 || maxMarket > 0)) {
    errors['Market Range'] = 'Minimum must be less than Maximum ***';
  }

  // 🔥 SHOW ERRORS
  setValidationErrors(errors);
  setShowValidationErrors(Object.keys(errors).length > 0);
  
  return Object.keys(errors).length === 0;
};

const handleSaveEdit = async () => {
  try {

     if (discountError) {
    setShowPopup(true);
    setPopupType('400');
    setPopupMessage("Please correct the discount error before saving.");
    return;
  }

    if (marginError) {
    setShowPopup(true);
    setPopupType('400');
    setPopupMessage("Please correct the margin error before saving.");
    return;
  }
    setIsSaving(true);
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    
    // 🔥 CAPTURE ALL DROPDOWN VALUES + editData
    const updateData = {
      _id: selectedProduct._id,
      ...editData,

       specifications: JSON.stringify(
    rows
      .filter(row => row.Name.trim() !== '' && row.Value.trim() !== '')
      .map(row => ({ [row.Name.trim()]: row.Value.trim() }))
  ),
      
      // 🔥 DROPDOWN VALUES - Convert dropdown objects to IDs
      product_category_id: selectedProductCategoryDropdown?.value || selectedProduct?.product_category_id?._id || null,
      product_sub_category_id: selectedProductSubCategoryDropdown?.value || selectedProduct?.product_sub_category_id?._id || null,
      vendor_id: selectedVendorDropdown?.value || selectedProduct?.vendor_id?._id || null,
      product_group_id: selectedGroupDropdown?.value || selectedProduct?.product_group_id?._id || null,
      UOM_id: selectedUOMDropdown?.value || selectedProduct?.UOM_id?._id || null,
      is_active: editData.is_active ?? selectedProduct?.is_active ?? true,

      
      // 🔥 Convert alternate_names back to array
      alternate_names: editData.alternate_names
        ?.split(',')
        .map(name => name.trim())
        .filter(name => name) || [],
    };

    console.log('🔥 SENDING UPDATE DATA:', updateData); // Debug log

    const response = await fetch(`${backendApiUrl}product/update-product`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(updateData),
    });

    const data = await response.json();
    console.log('Update response:', data);
    
    if (data.status === 200 || data.status === 201) {
      setShowPopup(true);
      setPopupType('200or201');
      setPopupMessage('Item updated successfully!');
      
      setTimeout(async () => {
        // 🔥 REFRESH ALL DATA after successful save
        await fetchItems(selectedProduct);
        await getProductDetails(selectedProduct._id);
        
        // 🔥 RESET DROPDOWN STATES to match updated data
        if (data.data) {
          const updatedProduct = data.data;
          
          // Update dropdown states with fresh data
          if (updatedProduct.product_category_id?._id) {
            setSelectedProductCategoryDropdown({
              value: updatedProduct.product_category_id._id,
              label: updatedProduct.product_category_id.product_category_name
            });
          }
          
          if (updatedProduct.product_sub_category_id?._id) {
            setSelectedProductSubCategoryDropdown({
              value: updatedProduct.product_sub_category_id._id,
              label: updatedProduct.product_sub_category_id.product_sub_category_name
            });
          }
          
          if (updatedProduct.vendor_id?._id) {
            setSelectedVendorDropdown({
              value: updatedProduct.vendor_id._id,
              label: updatedProduct.vendor_id.name || updatedProduct.vendor_id.vendor_name
            });
          }
          
          if (updatedProduct.product_group_id?._id) {
            setSelectedGroupDropdown({
              value: updatedProduct.product_group_id._id,
              label: updatedProduct.product_group_id.product_group_name
            });
          }
          
          if (updatedProduct.UOM_id?._id) {
            setSelectedUOMDropdown({
              value: updatedProduct.UOM_id._id,
              label: updatedProduct.UOM_id.UOM
            });
          }
        }
        
        setIsEditMode(false);
        setEditData({});
        setShowPopup(false);
      }, 1500);
    } else {
      setShowPopup(true);
      setPopupType('400');
      setPopupMessage(data.message || 'Update failed');
    }
  } catch (error) {
    console.error('Update error:', error);
    setShowPopup(true);
    setPopupType('500');
    setPopupMessage('Update failed. Please try again.');
  } finally {
    setIsSaving(false);
  }
};

const handleGalleryImages = async (e) => {

    const files = Array.from(e.target.files);

    if (!files.length) return;

    const formData = new FormData();

    formData.append("_id", selectedProduct._id);

    files.forEach(file => {
        formData.append("more_images", file);
    });

    const token = decryptData(sessionStorage.getItem("token"));

    const response = await fetch(
        `${backendApiUrl}product/change-product-images`,
        {
            method: "PUT",
            headers: {
               "x-token": token
            },
            body: formData
        }
    );

    const result = await response.json();

    console.log("result:",result)

    if (result.success) {

        setExistingImages(result.data.more_images);

        setPopupMessage("Images added successfully");
        setPopupType("200");
        setShowPopup(true);
    }
};

const deleteGalleryImage = async (imageId) => {

    const token = decryptData(sessionStorage.getItem("token"));

    const response = await fetch(
        `${backendApiUrl}product/delete-product-image`,
        {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "x-token":token
            },
            body: JSON.stringify({
                product_id: selectedProduct._id,
                image_id: imageId
            })
        }
    );

    const result = await response.json();

    console.log("result:",result);

    if (result.success) {

        setExistingImages(prev =>
            prev.filter(img => img._id !== imageId)
        );

        setPopupMessage("Image deleted");
        setPopupType("200");
        setShowPopup(true);
    }
};

  

  return (

    <div className=" bg-white flex flex-row w-full justify-center overflow-y-hidden">
      {/* List of Customers Div start */}
      <div className=" flex flex-col  w-[32%]  ">
  <div className="p-4 border-b  flex flex-row justify-between ">
      <div>
      <h5 className="text-md font-semibold cursor-pointer ">All Items
       <FontAwesomeIcon icon={faChevronDown} className="text-xs mb-0.5 text-blue-600 mx-1 cursor-pointer " />
      </h5>
      </div>
      <div className=''>
      <button onClick={handleCreateItem}
    className="mr-2 bg-[#f7525a] text-white px-1 py-0.5 rounded-md" 
     title="" data-tooltip="Create Item"  style={{ '--tooltip-bg': 'black' }}>
    <FontAwesomeIcon icon={faPlus} className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
  </button>
  </div>
    </div>
    <div className='flex justify-center items-center mt-2 pb-2 px-3 border-b'>
      <div className="mx-auto">
    
<Search
  searchQuery={searchQuery}
  setSearchQuery={setSearchQuery}
  searchType={searchType}
  setSearchType={setSearchType}
  searchTypes={searchTypes}
  placeholder="Search item details..."
  onSearch={handleSearch}          
  onSearchSubmit={handleSearch} 
   onClear={handleClearSearch} 
   
   
/>
</div>
  </div>

  <div className=" flex justify-center  overflow-y-hidden  flex-col ">
   <div className='flex  flex-col h-[80vh]  overflow-y-auto pb-10 relative' 
     ref={listContainerRef}>

       {searchQuery && itemsToDisplay.length === 0 && (
    <div className="flex justify-center items-center py-10">
    <div className="flex flex-col items-center text-gray-500">
  <FontAwesomeIcon
    icon={faSearch}
    className="text-2xl mb-2"
  />
  <p className="text-sm">No Results Found</p>
</div>
    </div>
  )}

   {itemsToDisplay.map((product) => (
        <div
          key={product._id}
         ref={(el) => (itemRefs.current[product._id] = el)}
          onClick={() => handleProductClick(product)}
          className={` border-b text-sm flex items-center px-4 py-2 ${selectedProduct?._id === product._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
        >
          <div className='w-full flex flex-row justify-between'>
            <div className='w-[10%]'>
              <input type="checkbox" className="mr-2 border border-gray-400 shadow-sm hover:shadow-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded" />
            </div>
            <div className='w-[80%] flex flex-col'>
              <div>
              <p className='text-xs font-semibold pr-4 ' >{product.product_name}</p>
              </div>
              {product?.UOM_id && (
  <div className='text-gray-800 mt-2 flex flex-row'>
    <p className='text-xs mr-1'>Units : </p>
    <p className='text-xs'>{product.UOM_id.UOM}</p>
  </div>
)}
            </div>
            {product?.selling_price && (
            <div className='w-[10%] flex justify-end'> 
                <p className='text-md font-semibold' >₹{product.selling_price.toLocaleString()}</p>
              </div>
            )}
          </div>
        </div>
      ))}
  </div>
</div>
</div>
{/* List of Customers Div end */}

<div className="border-l w-full flex flex-col">
      {selectedProduct ? (
        <>
          <div className="border-b h-20 overflow-visible"> {/* or h-12, depending on your desired height */}
            <div className='p-4 flex justify-between items-center relative'>
              <span className="text-md font-semibold">{selectedProduct?.product_name}</span>
              <div className="flex items-center space-x-2 px-2">
           
  <button
    type="button"
    onClick={() => HandleMoqs()}
    className="px-3 py-1 bg-white text-blue-600 border border-blue-500 rounded-md text-sm flex items-center hover:bg-blue-50 transition-colors duration-200"
  >
    <FontAwesomeIcon icon={faPlusCircle} className="mr-2 text-blue-500" />
    MOQs
  </button>

    <div className="relative" ref={assignDropdownRef}>
  <button
    className="bg-gray-100 text-sm px-2 py-1 shadow-sm border rounded-md mr-2"
    onClick={handleOpenAssign}
  >
    Assign
  </button>

  {assignType && (
    <div className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-28  rounded-md shadow-lg z-[9999]">

      <div
        className="py-1 px-2 text-center hover:bg-[#f7525a] hover:text-white cursor-pointer"
        onClick={() => handleAssignTypeSelect("attributes")}
      >
        Attributes
      </div>

    </div>
  )}
</div>
  
 <button 
  className={`px-3 py-1 ${isEditMode ? 'bg-emerald-100 text-emerald-700 border-emerald-300' : 'bg-gray-100 text-gray-700 border-gray-300'} rounded-md text-sm hover:bg-gray-200 transition-colors duration-200`}
  onClick={handleEditItem}
>
  {isEditMode ? 'Editing...' : 'Edit'}
</button>
  
  {/* Uncomment if needed
  <button className="px-3 py-1 bg-gray-100 text-gray-700 border border-gray-300 rounded-md text-sm flex items-center hover:bg-gray-200 transition-colors duration-200">
    <FontAwesomeIcon icon={faPaperclip} className="mr-2" />
    Attach
  </button>
  
  <button className="px-3 py-1 bg-[#f7525a] text-white border border-[#f7525a] rounded-md text-sm hover:bg-[#e54643] transition-colors duration-200">
    New Transaction
  </button>
  
  <button
    className="px-3 py-1 bg-gray-100 text-gray-700 border border-gray-300 rounded-md text-sm hover:bg-gray-200 transition-colors duration-200"
    onClick={() => setShowRequiredPopup(!showRequiredPopup)}
  >
    Assign
  </button>
  */}
  
  <button 
    className="p-1 text-[#f7525a] hover:text-[#e54643] transition-colors duration-200 rounded-md"
    onClick={handleClose}
    title="Close"
  >
    <FontAwesomeIcon icon={faX} className="text-md" />
  </button>
</div>

            </div>
          </div>
          {ProductLoader ? (
    <Loader />
  ) : (
          <div className="h-5/6 w-full flex justify-center">
            <div className="flex flex-row h-full w-full">
              <div className="flex flex-1 h-full flex-col">
      <div className="flex flex-col h-[80vh] overflow-y-auto bg-white ">
  
  

 <div className={`p-4 space-y-6 ${isEditMode ? 'pb-32' : ''}`}>
  {/* 1. BASIC PRODUCT INFO */}
<section>
  <div className="flex items-center gap-2 mb-2">
    <h3 className="text-sm text-[1rem] font-semibold">
      Product Information
    </h3>
  </div>

  <div className="p-2 bg-white border border-gray-200 rounded-2xl shadow-sm">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      {/* Category */}
      <div className="p-2 text-center hover:bg-gray-50 rounded-lg transition">
        <div className="flex items-center justify-center gap-1.5 mb-0.5">
 {!isEditMode && (
    <div className="w-7 h-7 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center text-xs">
      🏷️
    </div>
  )}
  <span className={`text-sm ${
  isEditMode 
    ? 'text-red-600'  
    : 'text-gray-500'
  }`}>
  Item Category {isEditMode && '*'}
</span>       
 </div>

        <div className="min-h-[36px] flex items-center justify-center">
          {isEditMode ? (
            <div className="w-full">
             <CustomDropdown
  options={dropdownCategories}
  selected={selectedProductCategoryDropdown}
   placeholder="Select Category"
  onSelect={(value, label) => {
    setSelectedProductCategoryDropdown({ value, label });
    setProductCategory({ _id: value, product_category_name: label });
    // 🔥 Reset dependent dropdowns
    setSelectedProductSubCategoryDropdown(null);
    setProductSubCategory(null);
    setSelectedGroupDropdown(null);
    setDropdownGroups([]);
    // 🔥 Fetch subcategories + vendors
    fetchDropdownSubCategories(value);
  }}
/>
            </div>
          ) : (
            <span className="font-semibold text-sm text-blue-700">
              {productCategory?.product_category_name ||
                productCategory?.category_name ||
                "Uncategorized"}
            </span>
          )}
        </div>
      </div>

      {/* Subcategory */}
      <div className="p-2 text-center hover:bg-gray-50 rounded-lg transition">
        <div className="flex items-center justify-center gap-1.5 mb-0.5">
          {!isEditMode && (
          <div className="w-7 h-7 bg-indigo-50 text-indigo-600 rounded-lg flex items-center justify-center text-xs">📂</div>
          )}
          <span className="text-sm text-gray-500">Sub Category</span>
        </div>

        <div className="min-h-[36px] flex items-center justify-center">
          {isEditMode ? (
            <div className="w-full">
              <CustomDropdown
                options={dropdownSubCategories}
                selected={selectedProductSubCategoryDropdown}
                 placeholder="Select SubCategory"
                onSelect={(value, label) => {
                  setSelectedProductSubCategoryDropdown({ value, label });
                  setProductSubCategory({
                    _id: value,
                    product_sub_category_name: label,
                  });
                }}
                disabled={!selectedProductCategoryDropdown}
              />
            </div>
          ) : (
            <span className="font-semibold text-sm text-indigo-700 truncate">
              {productSubCategory?.product_sub_category_name ||
                productSubCategory?.subcategory_name ||
                "N/A"}
            </span>
          )}
        </div>
      </div>
        {/* Vendor */}
      <div className="p-2 text-center hover:bg-gray-50 rounded-lg transition">
        <div className="flex items-center justify-center gap-1.5 mb-0.5">
          {!isEditMode && (
          <div className="w-7 h-7 bg-emerald-50 text-emerald-600 rounded-lg flex items-center justify-center text-xs">👤</div>
          )}
<span className={`text-sm  ${
  isEditMode 
    ? 'text-red-600'  
    : 'text-gray-500' 
  }`}>
  Vendor Name{isEditMode && '*'}
</span>             </div>

        <div className="min-h-[36px] flex items-center justify-center">
          {isEditMode ? (
            <div className="w-full">
              <CustomDropdown
  options={dropdownVendors}
  selected={selectedVendorDropdown}
   placeholder="Select Vendor"
  onSelect={(value, label) => {
    setSelectedVendorDropdown({ value, label });
    setvendor({ _id: value, vendor_name: label });
    // 🔥 Fetch filtered groups when both category + vendor available
    if (selectedProductCategoryDropdown?.value) {
      fetchDropdownGroups(selectedProductCategoryDropdown.value, value);
    }
  }}
/>
            </div>
          ) : (
            <span className="font-semibold text-sm text-emerald-700 truncate">
              {vendor?.vendor_name || "N/A"}
            </span>
          )}
        </div>
      </div>
      {/* Item Group */}
      <div className="p-2 text-center hover:bg-gray-50 rounded-lg transition">
        <div className="flex items-center justify-center gap-1.5 mb-0.5">
          {!isEditMode && (
          <div className="w-7 h-7 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center text-xs">🏷️</div>
          )}
          <span className="text-sm text-gray-500">Item Group</span>
        </div>

        <div className="min-h-[36px] flex items-center justify-center">
          {isEditMode ? (
            <div className="w-full">
              <CustomDropdown
                options={dropdownGroups}
                selected={selectedGroupDropdown}
                 placeholder="Select Item Group"
                onSelect={(value, label) => {
                  setSelectedGroupDropdown({ value, label });
                  setProductgroup({ _id: value, product_group_name: label });
                }}
              />
            </div>
          ) : (
            <span className="font-semibold text-sm text-purple-700 truncate">
              {selectedProduct?.product_group_id?.product_group_name ||
                productGroup?.product_group_name ||
                "N/A"}
            </span>
          )}
        </div>
      </div>

    
      {/* Product Name */}
      <div className="p-2 text-center hover:bg-gray-50 rounded-lg transition">
        <div className="flex items-center justify-center gap-1.5 mb-0.5">
          {!isEditMode && (
          <div className="w-7 h-7 bg-gray-50 text-gray-600 rounded-lg flex items-center justify-center text-xs">📝</div>
          )}
<span className={`text-sm  ${
  isEditMode 
    ? 'text-red-600 '  
    : 'text-gray-500' 
  }`}>
  Product Name {isEditMode && '*'}
</span>     

        </div>

        <div className="min-h-[36px] flex items-center justify-center">
          {isEditMode ? (
            <input
              type="text"
              value={editData.product_name}
              onChange={(e) =>
                setEditData({ ...editData, product_name: e.target.value })
              }
              className="w-full border border-gray-300 rounded-md px-2 text-sm text-center focus:ring-2 focus:ring-blue-500 py-1"
            />
          ) : (
            <span className="font-semibold text-sm text-gray-900">
              {selectedProduct?.product_name || "N/A"}
            </span>
          )}
        </div>
      </div>

      {/* UOM */}
      <div className="p-2 text-center hover:bg-gray-50 rounded-lg transition">
        <div className="flex items-center justify-center gap-1.5 mb-0.5">
          {!isEditMode && (
          <div className="w-7 h-7 bg-orange-50 text-orange-600 rounded-lg flex items-center justify-center text-xs">📏</div>
          )}
<span className={`text-sm  ${
  isEditMode 
    ? 'text-red-600' 
    : 'text-gray-500' 
  }`}>
  UOM{isEditMode && '*'}
</span>       

      </div>

        <div className="min-h-[36px] flex items-center justify-center">
          {isEditMode ? (
            <div className="w-full">
              <CustomDropdown
                options={dropdownUOMs}
                selected={selectedUOMDropdown}
                placeholder="Select UOM"
                onSelect={(value, label) =>
                  setSelectedUOMDropdown({ value, label })
                }
              />
            </div>
          ) : (
            <span className="font-semibold text-sm text-orange-700 truncate">
              {selectedProduct?.UOM ||
                selectedProduct?.UOM_id?.UOM ||
                "N/A"}
            </span>
          )}
        </div>
      </div>
    </div>
  </div>
</section>

{/* 🔥 PRICING & PURCHASE DETAILS - MATCHING UI */}
<section>
  <div className="flex items-center gap-2 mb-3">
    <h3 className="text-sm font-semibold">SKU Details</h3>
  </div>

  <div className="p-3 bg-white border border-gray-200 rounded-xl shadow-sm">
    
    {/* HEADER ROW (Icon + Label) */}
    <div className="grid grid-cols-5 text-center mb-2">
      
      {/* 1. SKU */}
      <div className="flex flex-col items-center gap-[2px]">
        <div className="w-7 h-7 bg-indigo-50 text-indigo-600 rounded-md flex items-center justify-center text-xs">🆔</div>
        <span className="text-sm text-gray-500">SKU</span>
      </div>

      {/* 2. HSN Code */}
      <div className="flex flex-col items-center gap-[2px]">
        <div className="w-7 h-7 bg-red-50 text-red-600 rounded-md flex items-center justify-center text-xs">📋</div>
        <span className="text-sm text-gray-500">HSN Code</span>
      </div>

      {/* 3. Purchase Mode */}
      <div className="flex flex-col items-center gap-[2px]">
        <div className="w-7 h-7 bg-emerald-50 text-emerald-600 rounded-md flex items-center justify-center text-xs">🛒</div>
        <span className="text-sm text-gray-500">Purchase Mode</span>
      </div>

      {/* 4. Eligible Qty */}
      <div className="flex flex-col items-center gap-[2px]" 
           style={{ 
             display: isEditMode 
               ? (editData.purchase_mode === 'Both' ? 'flex' : 'none') 
               : (selectedProduct?.purchase_mode === 'Both' ? 'flex' : 'none')
           }}>
        <div className="w-7 h-7 bg-orange-50 text-orange-600 rounded-md flex items-center justify-center text-xs">⚠️</div>
        <span className="text-sm text-gray-500">Eligible Qty</span>
      </div>

      {/* 5. Status (Product Active) */}
      <div className="flex flex-col items-center gap-[2px]">
        <div className="w-7 h-7 bg-green-50 text-green-600 rounded-md flex items-center justify-center text-xs">⚡</div>
        <span className="text-sm text-gray-500">Product Active </span>
      </div>

    </div>

    {/* VALUES ROW */}
    <div className="grid grid-cols-5 text-center items-center">

      {/* 1. SKU */}
      <div>
        {isEditMode ? (
          <input
            type="text"
            value={editData.SKU}
            onChange={(e) => setEditData({ ...editData, SKU: e.target.value })}
            className="w-24 border border-gray-300 rounded px-2 py-1 text-sm text-center"
          />
        ) : (
          <span className="font-semibold text-sm text-indigo-700">
            {selectedProduct?.SKU || "N/A"}
          </span>
        )}
      </div>

      {/* 2. HSN */}
      <div>
        {isEditMode ? (
          <input
            type="text"
            value={editData.HSN_Code}
            onChange={(e) => setEditData({ ...editData, HSN_Code: e.target.value })}
            className="w-24 border border-gray-300 rounded px-2 py-1 text-xs text-center"
          />
        ) : (
          <span className="font-semibold text-sm text-red-700">
            {selectedProduct?.HSN_Code || "N/A"}
          </span>
        )}
      </div>

      {/* 3. Purchase Mode */}
      <div className="px-2">
        {isEditMode ? (
          <select
            value={editData.purchase_mode}
            onChange={(e) => setEditData({ ...editData, purchase_mode: e.target.value })}
            className="w-full border border-gray-300 rounded px-1 py-1 text-sm text-center"
          >
            <option value="Both">Both</option>
            <option value="Quote">Quote</option>
            <option value="Instant Buy">Instant Buy</option>
          </select>
        ) : (
          <span className="font-semibold text-sm text-emerald-700">
            {selectedProduct?.purchase_mode || "N/A"}
          </span>
        )}
      </div>

      {/* 4. Threshold */}
       <div style={{ 
        display: isEditMode 
          ? (editData.purchase_mode === 'Both' ? 'block' : 'none') 
          : (selectedProduct?.purchase_mode === 'Both' ? 'block' : 'none')
      }}>
        {isEditMode ? (
          <input
            type="number"
            value={editData.quote_threshold_quantity}
            onChange={(e) =>
              setEditData({ ...editData, quote_threshold_quantity: e.target.value })
            }
            className="w-16 border border-gray-300 rounded px-2 py-1 text-sm text-center mx-auto block"
          />
        ) : (
          <span className="font-semibold text-sm text-orange-700">
            {selectedProduct?.quote_threshold_quantity || "N/A"}
          </span>
        )}
      </div>

      {/* 5. Product Active Toggle */}
      <div className="flex justify-center">
        {isEditMode ? (
          <button
            type="button"
            onClick={() =>
              setEditData((prev) => ({
                ...prev,
                is_active: !(prev?.is_active ?? selectedProduct?.is_active),
              }))
            }
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-all duration-300 focus:outline-none ${
              (editData?.is_active ?? selectedProduct?.is_active) === true
                ? "bg-blue-500"
                : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition duration-300 ${
                (editData?.is_active ?? selectedProduct?.is_active) === true
                  ? "translate-x-5"
                  : "translate-x-1"
              }`}
            />
          </button>
        ) : (
          <span
            className={`text-sm font-semibold ${
              selectedProduct?.is_active
                ? "text-green-600"
                : "text-red-500"
            }`}
          >
            {selectedProduct?.is_active ? "Yes" : "No"}
          </span>
        )}
      </div>

    </div>
  </div>
</section>
  


  {/* 2. TAX INFORMATION */}
  <section>
  {/* Header */}
  <div className="flex items-center gap-2 mb-3">
    <h3 className="text-sm font-semibold">Tax Information</h3>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-2 bg-white border border-gray-200 rounded-2xl shadow-sm">

    {/* Tax Preference */}
    <div className="flex flex-col items-center text-center p-3 border-r border-gray-100">
       <span className={`text-sm ${
  isEditMode 
    ? 'text-red-600'  
    : 'text-gray-500'
  }`}>
  Tax Preference {isEditMode && '*'}
</span>       

      {isEditMode ? (
        <select
          value={editData.tax_preference}
          onChange={(e) =>
            setEditData({ ...editData, tax_preference: e.target.value })
          }
          className="font-semibold text-sm border border-gray-300 rounded-md p-1.5 focus:ring-1 focus:ring-blue-500 w-full text-center"
        >
          <option value="">Select</option>
          <option value="Taxable">Taxable</option>
          <option value="Non-Taxable">Non-Taxable</option>
          <option value="Non-GST Supply">Non-GST Supply</option>
        </select>
      ) : (
        <span className="font-semibold text-sm text-gray-900">
          {selectedProduct?.tax_preference || "N/A"}
        </span>
      )}
    </div>

    {/* 🔥 GST - HIDE WHEN NOT "Taxable" */}
    <div className="flex flex-col items-center text-center p-3 border-r border-gray-100" 
         style={{ 
           display: isEditMode 
             ? (editData.tax_preference === 'Taxable' ? 'flex' : 'none') 
             : (selectedProduct?.tax_preference === 'Taxable' ? 'flex' : 'none')
         }}>
      <span className="text-sm text-gray-500 mb-1">GST</span>

      {isEditMode ? (
        <input
          type="number"
          min="0"
          max="100"
          step="0.01"
          value={editData.GST}
          onChange={(e) =>
            setEditData({ ...editData, GST: e.target.value })
          }
          className="font-bold text-sm text-green-600 border border-gray-300 rounded-md p-1.5 focus:ring-1 focus:ring-blue-500 w-full text-center"
          placeholder="0"
        />
      ) : (
        <span className="font-bold text-sm text-green-600">
          {selectedProduct?.GST || 0}%
        </span>
      )}
    </div>

    {/* 🔥 IGST - HIDE WHEN NOT "Taxable" */}
    <div className="flex flex-col items-center text-center p-3" 
         style={{ 
           display: isEditMode 
             ? (editData.tax_preference === 'Taxable' ? 'flex' : 'none') 
             : (selectedProduct?.tax_preference === 'Taxable' ? 'flex' : 'none')
         }}>
      <span className="text-sm text-gray-500 mb-1">IGST</span>

      {isEditMode ? (
        <input
          type="number"
          min="0"
          max="100"
          step="0.01"
          value={editData.IGST}
          onChange={(e) =>
            setEditData({ ...editData, IGST: e.target.value })
          }
          className="font-bold text-sm text-green-600 border border-gray-300 rounded-md p-1.5 focus:ring-1 focus:ring-blue-500 w-full text-center"
          placeholder="0"
        />
      ) : (
        <span className="font-bold text-sm text-green-600">
          {selectedProduct?.IGST || 0}%
        </span>
      )}
    </div>

  </div>
</section>

  {/* 3. PRICING INFORMATION */}
<section>
  {/* Header */}
  <div className="flex items-center gap-2 mb-3">
    <h3 className="text-sm font-semibold">Pricing Information</h3>
  </div>

  <div className="p-2 bg-white border border-gray-200 rounded-2xl shadow-sm">
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      
      {/* MRP */}
      <div className="text-center p-3">
        <div className="w-9 h-9 bg-blue-50 text-blue-600 rounded-xl mx-auto flex items-center justify-center mb-1">
          💳
        </div>
        <span className={`text-sm block mb-1 ${
          isEditMode 
            ? 'text-red-600 font-medium'  
            : 'text-gray-500'
        }`}>
          MRP {isEditMode && '*'}
        </span>       

        {isEditMode ? (
          <input
            type="text"
            min="0"
            step="0.01"
            value={pricingData.mrp || editData.mrp || ''}
            onChange={(e) => handlePricingChange('mrp', e.target.value)}
            className="text-sm font-bold border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400 transition-all"
            placeholder="0"
          />
        ) : (
          <span className="text-sm font-bold text-gray-900">
            ₹{Number(selectedProduct?.mrp || 0).toLocaleString()}
          </span>
        )}
      </div>

      {/* Discount */}
      <div className="text-center p-3 border-l border-gray-100">
        <div className="w-9 h-9 bg-orange-50 text-orange-600 rounded-xl mx-auto flex items-center justify-center mb-1">
          🏷️
        </div>
        <span className="text-sm text-gray-500 block mb-1">Discount</span>

        {isEditMode ? (
          <>
          <input
            type="text"
            value={pricingData.discount || editData.discount || ''}
            onChange={(e) => handlePricingChange('discount', e.target.value)}
            className="text-sm font-semibold border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-orange-500 focus:border-orange-500 hover:border-orange-400 transition-all"
            placeholder="0"
          />
          {discountError && (
        <span className="text-xs text-red-500 font-bold block mt-1">{discountError}</span>
      )}
      </>
        ) : (
          <span className="text-sm font-semibold text-orange-600">
            {Number(selectedProduct?.discount || 0)}%
          </span>
        )}
      </div>

      {/* Cost Price */}
      <div className="text-center p-3 border-l border-gray-100">
        <div className="w-9 h-9 bg-emerald-50 text-emerald-600 rounded-xl mx-auto flex items-center justify-center mb-1">
          💰
        </div>
        <span className={`text-sm block mb-1 ${
          isEditMode 
            ? 'text-red-600 font-medium'  
            : 'text-gray-500'
        }`}>
          Cost Price {isEditMode && '*'}
        </span>       

        {isEditMode ? (
          <input
            type="number"
            min="0"
            step="0.01"
            value={pricingData.cost_price || editData.cost_price || ''}
            onChange={(e) => handlePricingChange('cost_price', e.target.value)}
            className="text-sm font-bold border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 hover:border-emerald-400 transition-all"
            placeholder="0"
          />
        ) : (
          <span className="text-sm font-bold text-emerald-700">
            ₹{Number(selectedProduct?.cost_price || 0).toLocaleString()}
          </span>
        )}
      </div>

      {/* Margin */}
      <div className="text-center p-3 border-l border-gray-100">
        <div className="w-9 h-9 bg-green-50 text-green-600 rounded-xl mx-auto flex items-center justify-center mb-1">
          📈
        </div>
        <span className="text-sm text-gray-500 block mb-1">Margin</span>

        {isEditMode ? (
          <>
          <input
            type="text"
            value={pricingData.margin_rate || ''}
            onChange={(e) => handlePricingChange('margin_rate', e.target.value)}
            className="text-sm font-semibold border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-green-500 focus:border-green-500 hover:border-green-400 transition-all"
            placeholder="0"
          />
             {marginError && (
        <span className="text-[10px] text-red-500 font-bold block mt-1">{marginError}</span>
      )}
      </>
        ) : (
          <span
            className={`text-sm font-semibold px-2 py-1 rounded-md inline-block ${
              Number(selectedProduct?.margin_rate || 0) > 10
                ? ' text-yellow-700'
                : ' text-yellow-700'
            }`}
          >
            {Number(selectedProduct?.margin_rate || 0)}%
          </span>
        )}
      </div>

      {/* Selling Price */}
      <div className="text-center p-3 border-l border-gray-100">
        <div className="w-9 h-9 bg-emerald-100 text-emerald-600 rounded-xl mx-auto flex items-center justify-center mb-1">
          🛒
        </div>
        <span className={`text-sm block mb-1 ${
          isEditMode 
            ? 'text-red-600 font-medium'  
            : 'text-gray-500'
        }`}>
          Selling Price {isEditMode && '*'}
        </span>       

        {isEditMode ? (
          <input
            type="number"
            min="0"
            step="0.01"
            value={pricingData.selling_price || editData.selling_price || ''}
            onChange={(e) => handlePricingChange('selling_price', e.target.value)}
            className={`text-sm font-bold border rounded-md p-1.5 w-full text-center transition-all ${
              isPricingInvalid 
                ? 'border-red-400 bg-red-50 focus:ring-red-500 focus:border-red-500 ring-2 ring-red-200' 
                : 'border-gray-300 focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 hover:border-emerald-400'
            }`}
            placeholder="0"
          />
        ) : (
          <span className="text-sm font-bold text-emerald-700  px-3 py-1 rounded-md inline-block">
            ₹{Number(selectedProduct?.selling_price || 0).toLocaleString()}
          </span>
        )}

        {isPricingInvalid && isEditMode && (
          <div className="mt-2 flex items-center justify-center gap-1 text-xs text-red-600 bg-red-50 border border-red-200 px-3 py-1.5 rounded-lg font-medium">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            Selling price cannot be less than cost price
          </div>
        )}
      </div>

    </div>
  </div>
</section>

  {/* 4. MARKET RANGE & QUANTITY LIMITS */}
  <section>
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
    
    {/* Market Range */}
    <div className="p-4 bg-white border border-gray-200 rounded-2xl shadow-sm">
      <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
        📊 Market Price Range
      </h4>

      <div className="grid grid-cols-2 gap-4">
        
        <div className="p-4 bg-gradient-to-b from-green-50 to-emerald-50 rounded-xl border">
           <span className={`text-sm block mb-1 ${
  isEditMode 
    ? 'text-red-600'  
    : 'text-gray-500'
  }`}>
  Minimum {isEditMode && '*'}
</span>       

          {isEditMode ? (
            <input
              type="number"
              min="0"
              value={editData.market_range?.min || ''}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  market_range: {
                    ...editData.market_range,
                    min: e.target.value,
                  },
                })
              }
              className="text-sm font-bold text-green-600 border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-green-500"
              placeholder="0"
            />
          ) : (
            <span className="text-sm font-bold text-green-600 block">
              ₹{(selectedProduct?.market_range?.min || 0).toLocaleString()}
            </span>
          )}
        </div>

        <div className="p-4 bg-gradient-to-b from-red-50 to-rose-50 rounded-xl border">
           <span className={`text-sm block mb-1 ${
  isEditMode 
    ? 'text-red-600'  
    : 'text-gray-500'
  }`}>
  Maximum {isEditMode && '*'}
</span>       

          {isEditMode ? (
            <input
              type="number"
              min="0"
              value={editData.market_range?.max || ''}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  market_range: {
                    ...editData.market_range,
                    max: e.target.value,
                  },
                })
              }
              className="text-sm font-bold text-red-600 border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-red-500"
              placeholder="0"
            />
          ) : (
            <span className="text-sm font-bold text-red-600 block">
              ₹{(selectedProduct?.market_range?.max || 0).toLocaleString()}
            </span>
          )}
        </div>
      </div>

      {marketRangeError && (
        <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded-lg text-[11px] text-red-600">
          ⚠️ {marketRangeError}
        </div>
      )}
    </div>

    {/* Quantity Limits */}
    <div className="p-4 bg-white border border-gray-200 rounded-2xl shadow-sm">
      <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
        📦 Quantity Limits
      </h4>

      <div className="grid grid-cols-2 gap-4">
        
        <div className="p-4 bg-gradient-to-b from-blue-50 to-indigo-50 rounded-xl border">
          <span className="text-sm text-gray-500 block mb-1">Minimum </span>

          {isEditMode ? (
            <input
              type="number"
              min="0"
              value={editData.quantity_limits?.min || ''}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  quantity_limits: {
                    ...editData.quantity_limits,
                    min: e.target.value,
                  },
                })
              }
              className="text-sm font-bold text-blue-600 border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-blue-500"
              placeholder="0"
            />
          ) : (
            <span className="text-sm font-bold text-blue-600">
              {selectedProduct?.quantity_limits?.min || '0'}
            </span>
          )}
        </div>

        <div className="p-4 bg-gradient-to-b from-purple-50 to-violet-50 rounded-xl border">
          <span className="text-sm text-gray-500 block mb-1">Maximum </span>

          {isEditMode ? (
            <input
              type="number"
              min="0"
              value={editData.quantity_limits?.max || ''}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  quantity_limits: {
                    ...editData.quantity_limits,
                    max: e.target.value,
                  },
                })
              }
              className="text-sm font-bold text-purple-600 border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-purple-500"
              placeholder="0"
            />
          ) : (
            <span className="text-sm font-bold text-purple-600">
              {selectedProduct?.quantity_limits?.max || '0'}
            </span>
          )}
        </div>

      </div>
    </div>

  </div>
</section>

 {/* 5. DIMENSIONS & WEIGHT */}
<section>
  {/* Header */}
  <div className="flex items-center gap-2 mb-3">
    <h3 className="text-sm font-semibold">Weight & Dimensions</h3>
  </div>

  <div className="flex flex-col md:flex-row gap-4 p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
    
    {/* ✅ Weight */}
<div className="flex flex-col justify-between w-full md:max-w-[180px]">
        {/* <span className="text-sm font-medium text-gray-600">Weight</span> */}

      {isEditMode ? (
         <>
    <span className="text-xs font-medium text-gray-500">Weight</span>
        <InputWithUnit
          value={editData.weight?.value || ''}
          unit={editData.weight?.unit || 'kg'}
          units={[
            { label: 'kg', value: 'kg' },
            { label: 'g', value: 'g' },
            { label: 'lb', value: 'lb' }
          ]}
          onChange={(val) =>
            setEditData(prev => ({
              ...prev,
              weight: { ...prev.weight, value: val }
            }))
          }
          onUnitChange={(unit) =>
            setEditData(prev => ({
              ...prev,
              weight: { ...prev.weight, unit }
            }))
          }
        />
          </>
      ) : (
         <div className="p-2 bg-gradient-to-r from-orange-50 to-orange-50 rounded-md border text-center">
              <span className="text-sm text-gray-600 block">Weight</span>
              <span className="text-sm font-bold text-orange-700">
                {/* {selectedProduct?.dimensions?.length || 0} */}
                <span className="text-sm ml-0.5">
                 {selectedProduct?.weight?.value || 0}{' '}
            {selectedProduct?.weight?.unit || 'kg'}
                </span>
              </span>
            </div>
      )}
    </div>

    {/* ✅ Dimensions */}
    <div className="flex flex-col space-y-1 flex-1">
      {/* <span className="text-sm font-medium text-gray-600 mb-1.5">Dimensions</span> */}

      <div className="grid grid-cols-3 gap-3">
        
        {/* Length */}
        <div>

          {isEditMode ? (
             <>
    <span className="text-xs font-medium text-gray-500 mb-1">Length</span>
            <InputWithUnit
              value={editData.dimensions?.length || ''}
              unit={editData.dimensions?.unit || 'cm'}
              units={[
                { label: 'mm', value: 'mm' },
                { label: 'cm', value: 'cm' },
                { label: 'm', value: 'm' },
                { label: 'inch', value: 'inch' },
                { label: 'ft', value: 'ft' }
              ]}
              onChange={(val) =>
                setEditData(prev => ({
                  ...prev,
                  dimensions: { ...prev.dimensions, length: val }
                }))
              }
              onUnitChange={(unit) =>
                setEditData(prev => ({
                  ...prev,
                  dimensions: { ...prev.dimensions, unit }
                }))
              }
            />
            </>
          ) : (
            <div className="p-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-md border text-center">
              <span className="text-sm text-gray-600 block">Length</span>
              <span className="text-sm font-bold text-blue-700">
                {selectedProduct?.dimensions?.length || 0}
                <span className="text-sm ml-0.5">
                  {selectedProduct?.dimensions?.unit || 'cm'}
                </span>
              </span>
            </div>
          )}
        </div>

        {/* Width */}
        <div>
          
          {isEditMode ? (
              <>
    <span className="text-xs font-medium text-gray-500 mb-1">Width</span>
            <InputWithUnit
              value={editData.dimensions?.width || ''}
              unit={editData.dimensions?.unit || 'cm'}
              units={[
                { label: 'mm', value: 'mm' },
                { label: 'cm', value: 'cm' },
                { label: 'm', value: 'm' },
                { label: 'inch', value: 'inch' },
                { label: 'ft', value: 'ft' }
              ]}
              onChange={(val) =>
                setEditData(prev => ({
                  ...prev,
                  dimensions: { ...prev.dimensions, width: val }
                }))
              }
              onUnitChange={(unit) =>
                setEditData(prev => ({
                  ...prev,
                  dimensions: { ...prev.dimensions, unit }
                }))
              }
            />
            </>
          ) : (
            <div className="p-2 bg-gradient-to-r from-green-50 to-emerald-50 rounded-md border text-center">
              <span className="text-sm text-gray-600 block">Width</span>
              <span className="text-sm font-bold text-emerald-700">
                {selectedProduct?.dimensions?.width || 0}
                <span className="text-sm ml-0.5">
                  {selectedProduct?.dimensions?.unit || 'cm'}
                </span>
              </span>
            </div>
          )}
        </div>

        {/* Height */}
        <div>
          {isEditMode ? (
            <>
    <span className="text-xs font-medium text-gray-500 mb-1">Height</span>
            <InputWithUnit
              value={editData.dimensions?.height || ''}
              unit={editData.dimensions?.unit || 'cm'}
              units={[
                { label: 'mm', value: 'mm' },
                { label: 'cm', value: 'cm' },
                { label: 'm', value: 'm' },
                { label: 'inch', value: 'inch' },
                { label: 'ft', value: 'ft' }
              ]}
              onChange={(val) =>
                setEditData(prev => ({
                  ...prev,
                  dimensions: { ...prev.dimensions, height: val }
                }))
              }
              onUnitChange={(unit) =>
                setEditData(prev => ({
                  ...prev,
                  dimensions: { ...prev.dimensions, unit }
                }))
              }
            />
            </>
          ) : (
            <div className="p-2 bg-gradient-to-r from-purple-50 to-violet-50 rounded-md border text-center">
              <span className="text-sm text-gray-600 block">Height</span>
              <span className="text-sm font-bold text-purple-700">
                {selectedProduct?.dimensions?.height || 0}
                <span className="text-sm ml-0.5">
                  {selectedProduct?.dimensions?.unit || 'cm'}
                </span>
              </span>
            </div>
          )}
        </div>

      </div>
    </div>
  </div>
</section>

  {/* 6. DELIVERY & AVAILABILITY */}
 <section>
  {/* Header */}
  <div className="flex items-center gap-2 mb-3">
    <h3 className="text-sm font-semibold">Delivery & Availability</h3>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-white border border-gray-200 rounded-2xl shadow-sm">
    {/* Delivered by Brickbucket */}
    <div className="flex flex-col items-center justify-center text-center gap-2 p-3 rounded-xl bg-emerald-50 border border-emerald-200">
      
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center text-sm">
          🚚
        </div>
        <span className="text-sm text-gray-600">
          Delivered by Brickbucket
        </span>
      </div>

      {isEditMode ? (
        <select
          value={editData.is_delivered_by_brickbucket ? 'true' : 'false'}
          onChange={(e) =>
            setEditData({
              ...editData,
              is_delivered_by_brickbucket: e.target.value === 'true',
            })
          }
          className="text-sm font-semibold border border-gray-300 rounded-md px-2 py-1 focus:ring-1 focus:ring-emerald-500 text-center"
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      ) : (
        <span
          className={`text-sm font-semibold ${
            selectedProduct?.is_delivered_by_brickbucket
              ? 'text-emerald-600'
              : 'text-gray-400'
          }`}
        >
          {selectedProduct?.is_delivered_by_brickbucket ? 'Yes' : 'No'}
        </span>
      )}
    </div>

    {/* COD Available */}
    <div className="flex flex-col items-center justify-center text-center gap-2 p-3 rounded-xl bg-blue-50 border border-blue-200">
      
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center text-sm">
          💳
        </div>
        <span className="text-sm text-gray-600">
          COD Available
        </span>
      </div>

      {isEditMode ? (
        <select
          value={editData.is_COD_available ? 'true' : 'false'}
          onChange={(e) =>
            setEditData({
              ...editData,
              is_COD_available: e.target.value === 'true',
            })
          }
          className="text-sm font-semibold border border-gray-300 rounded-md px-2 py-1 focus:ring-1 focus:ring-blue-500 text-center"
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      ) : (
        <span
          className={`text-sm font-semibold ${
            selectedProduct?.is_COD_available
              ? 'text-blue-600'
              : 'text-gray-400'
          }`}
        >
          {selectedProduct?.is_COD_available ? 'Yes' : 'No'}
        </span>
      )}
    </div>

    {/* Tax Included */}
    <div className="flex flex-col items-center justify-center text-center gap-2 p-3 rounded-xl bg-gray-50 border border-gray-200">
      
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center text-sm">
          💰
        </div>
        <span className="text-sm text-gray-600">
          Tax Included
        </span>
      </div>

      {isEditMode ? (
        <select
          value={editData.tax_included ? 'true' : 'false'}
          onChange={(e) =>
            setEditData({
              ...editData,
              tax_included: e.target.value === 'true',
            })
          }
          className="text-sm font-semibold border border-gray-300 rounded-md px-2 py-1 focus:ring-1 focus:ring-green-500 text-center"
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      ) : (
        <span
          className={`text-sm font-semibold ${
            selectedProduct?.tax_included
              ? 'text-green-600'
              : 'text-gray-400'
          }`}
        >
          {selectedProduct?.tax_included ? 'Yes' : 'No'}
        </span>
      )}
    </div>

  </div>
</section>
  {/* 7. ATTRIBUTES & SPECIFICATIONS - READ ONLY (as per original design) */}
  <section>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Attributes */}
   <div>
  <h4 className="text-sm font-semibold mb-3 flex items-center gap-2 text-gray-800">
    🏷️ Item Attributes
  </h4>

  {selectedProduct?.filterable_attributes?.length > 0 && productAttributes?.length > 0 ? (
    
    <div className="max-h-40 overflow-y-auto bg-gradient-to-b from-gray-50 to-white border border-gray-200 rounded-xl p-2 space-y-2">

      {selectedProduct.filterable_attributes.map((filter, index) => {
        let attribute = null;
        let attributeValue = null;

        for (const attr of productAttributes) {
          attributeValue = attr.attribute_values?.find(
            v => v.attribute_value_id === filter.attribute_value_id
          );
          if (attributeValue) {
            attribute = attr;
            break;
          }
        }

        if (!attribute || !attributeValue) return null;

        return (
          <div
            key={index}
            className="flex justify-between items-center px-3 py-2 bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-all duration-200"
          >
            {/* Attribute Name */}
            <span className="text-sm text-gray-600">
              {attribute.attribute_name}
            </span>

            {/* Attribute Value */}
            <span className="text-sm font-semibold text-gray-800 bg-gray-100 px-2 py-1 rounded-md">
              {attributeValue.attribute_value}
            </span>
          </div>
        );
      })}

    </div>

  ) : (
    <div className="p-3 text-center border border-dashed border-gray-300 rounded-xl bg-gray-50">
      <span className="text-sm text-gray-400">No attributes assigned</span>
    </div>
  )}
</div>

      {/* Specifications - READ ONLY */}
<div>
  {/* HEADER */}
  <div className="flex items-center justify-between mb-2">
    <h4 className="text-md font-semibold flex items-center gap-2">
      📋 Specifications
    </h4>

    {/* ADD BUTTON */}
    {isEditMode &&
      (!specifications || specifications.length === 0) &&
      !showSpecificationsTable && (
        <button
          onClick={() => {
            setShowSpecificationsTable(true);

            if (rows.length === 0) {
              setRows([{ SNo: 1, Name: "", Value: "" }]);
            }
          }}
          className="px-3 py-1 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600 transition-all flex items-center gap-1"
        >
          <FontAwesomeIcon icon={faPlusCircle} className="text-sm" />
          Add
        </button>
      )}
  </div>

  {/* VIEW MODE */}
  {!isEditMode && specifications?.length > 0 ? (
    <div className="max-h-40 overflow-y-auto bg-gradient-to-b from-gray-50 to-white border border-gray-200 rounded-xl p-2 space-y-2">
      {specifications.map((spec, specIdx) =>
        Object.entries(spec).map(([key, value]) => (
          <div
            key={`${specIdx}-${key}`}
            className="flex justify-between items-center px-3 py-2 bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-all duration-200"
          >
            <span className="text-sm text-gray-600 capitalize">
              {key.replace(/_/g, " ")}
            </span>
            <span className="text-sm font-semibold text-gray-900 bg-gray-100 px-2 py-1 rounded-md">
              {String(value)}
            </span>
          </div>
        ))
      )}
    </div>
  ) : (
    <>
      {/* ✅ EDIT MODE EMPTY STATE */}
     {(!specifications || specifications.length === 0) && !showSpecificationsTable && (
          <div className="p-3 text-center border border-dashed border-gray-300 rounded-xl bg-gray-50">
            <span className="text-gray-400 text-sm">
              No specifications available
            </span>
          </div>
        )}

      {/* ✅ EDIT MODE TABLE */}
      {showSpecificationsTable && (
        <div className="space-y-3">
          <div className="max-h-40 overflow-y-auto bg-white border border-gray-200 rounded-xl shadow-sm">
            <table className="w-full border-collapse">
              {/* 🔥 STICKY HEADER */}
              <thead className="sticky top-0 z-10 bg-[#fafafc]">
                <tr className="text-[#6c7184]">
                  <th className="font-semibold text-left text-sm py-2 px-2 border">
                    SNo
                  </th>
                  <th className="font-semibold text-left text-sm py-2 px-2 border">
                    Name
                  </th>
                  <th className="font-semibold text-left text-sm py-2 px-2 border">
                    Value
                  </th>
                  <th className="font-semibold text-left text-sm py-2 px-2 border">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td className="py-2 px-3 border text-sm font-medium">
                      {index + 1}
                    </td>

                    <td className="border">
                      <input
                        type="text"
                        value={row.Name}
                        onChange={(e) => {
                          const updatedRows = [...rows];
                          updatedRows[index].Name = e.target.value;
                          setRows(updatedRows);
                        }}
                        className="text-sm w-full p-2 outline-none focus:ring-1 focus:ring-blue-500 rounded-md"
                      />
                    </td>

                    <td className="border">
                      <input
                        type="text"
                        value={row.Value}
                        onChange={(e) => {
                          const updatedRows = [...rows];
                          updatedRows[index].Value = e.target.value;
                          setRows(updatedRows);
                        }}
                        className="text-sm w-full p-2 outline-none focus:ring-1 focus:ring-blue-500 rounded-md"
                      />
                    </td>

                    <td className="px-2 py-2 text-center">
                      <button
                        onClick={() => {
                          const updatedRows = rows.filter(
                            (_, i) => i !== index
                          );
                          setRows(updatedRows);
                        }}
                        className="text-red-500 hover:text-red-700"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ADD ROW BUTTON */}
          <button
            onClick={() => {
              const newRow = {
                SNo: rows.length + 1,
                Name: "",
                Value: "",
              };
              setRows([...rows, newRow]);
            }}
            className="px-2 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all flex items-center gap-2 text-sm"
          >
            <FontAwesomeIcon icon={faPlusCircle} />
            Add row
          </button>
        </div>
      )}
    </>
  )}
</div>

    </div>
  </section>


  {/* 9. ALTERNATIVE NAMES */}
  <section>
    <div className="flex items-center gap-3 mb-4">
      <h3 className="text-md text-[1rem] font-semibold">Alternative Names</h3>
    </div>
    {isEditMode ? (
      <div className="p-6 bg-white border border-gray-200 rounded-2xl shadow-sm">
        <textarea
          rows="3"
          value={editData.alternate_names}
          onChange={(e) => setEditData({...editData, alternate_names: e.target.value})}
          className="w-full p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical text-sm"
          placeholder="Enter alternative names (comma separated)"
        />
        <p className="text-sm text-gray-500 mt-2">Enter names separated by commas</p>
      </div>
    ) : (
      selectedProduct?.alternate_names && selectedProduct.alternate_names.length > 0 ? (
      <div className="flex flex-wrap gap-4 p-3 bg-white border border-gray-200 rounded-xl shadow-sm">
  {Array.isArray(selectedProduct.alternate_names) 
    ? selectedProduct.alternate_names.map((name, i) => (
        <span
          key={i}
          className="px-3 py-1 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-full hover:bg-blue-100 hover:border-blue-300 transition-all"
        >
          {name}
        </span>
      ))
    : selectedProduct.alternate_names.split(',').map((name, i) => (
        <span
          key={i}
          className="px-3 py-1 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-full hover:bg-blue-100 hover:border-blue-300 transition-all"
        >
          {name.trim()}
        </span>
      ))
  }
</div>
      ) : (
        <div className="p-3 text-center border border-dashed border-gray-300 rounded-lg bg-gray-50">
          <span className="text-gray-400 text-sm">No alternative names</span>
        </div>
      )
    )}
  </section>

  {/* 10. BUILDCIONS INFORMATION */}
 <section>
  {/* Header */}
  <div className="flex items-center gap-2 mb-3">
    <h3 className="text-sm font-semibold">Buildcoins Information</h3>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-gradient-to-r from-purple-50 to-violet-50 border border-purple-200 rounded-2xl shadow-sm">

    {/* Applicable */}
    <div className="flex flex-col items-center justify-center text-center gap-2 p-3 bg-white rounded-xl shadow-sm">
      
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center text-sm">
          ⭐
        </div>
        <span className="text-sm text-gray-600">
          Applicable
        </span>
      </div>

      {isEditMode ? (
        <select
          value={editData.is_buildcoins_applicable ? 'true' : 'false'}
          onChange={(e) =>
            setEditData({
              ...editData,
              is_buildcoins_applicable: e.target.value === 'true',
            })
          }
          className="text-sm font-semibold border border-gray-300 rounded-md px-2 py-1 focus:ring-1 focus:ring-purple-500 text-center"
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      ) : (
        <span
          className={`text-sm font-semibold ${
            selectedProduct?.is_buildcoins_applicable
              ? 'text-emerald-600'
              : 'text-gray-400'
          }`}
        >
          {selectedProduct?.is_buildcoins_applicable ? 'Yes' : 'No'}
        </span>
      )}
    </div>

    {/* Max Quantity */}
    <div className="flex flex-col items-center justify-center text-center gap-1 p-3 bg-white rounded-xl shadow-sm">
      
      <span className="text-sm text-gray-500">
        Max Quantity
      </span>

      {isEditMode ? (
        <input
          type="number"
          min="0"
          value={editData.buildcoins_max_quantity_applicable}
          onChange={(e) =>
            setEditData({
              ...editData,
              buildcoins_max_quantity_applicable: e.target.value,
            })
          }
          className="text-sm font-bold text-purple-600 border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-purple-500"
          placeholder="0"
        />
      ) : (
        <span className="text-sm font-bold text-purple-600">
          {selectedProduct?.buildcoins_max_quantity_applicable || 0}
        </span>
      )}
    </div>

    {/* Max Discount */}
    <div className="flex flex-col items-center justify-center text-center gap-1 p-3 bg-white rounded-xl shadow-sm">
      
      <span className="text-sm text-gray-500">
        Max Discount
      </span>

      {isEditMode ? (
        <input
          type="number"
          min="0"
          max="100"
          step="0.01"
          value={editData.buildcoins_max_discount}
          onChange={(e) =>
            setEditData({
              ...editData,
              buildcoins_max_discount: e.target.value,
            })
          }
          className="text-sm font-bold text-purple-600 border border-gray-300 rounded-md p-1.5 w-full text-center focus:ring-1 focus:ring-purple-500"
          placeholder="0"
        />
      ) : (
        <span className="text-sm font-bold text-purple-600">
          {selectedProduct?.buildcoins_max_discount || 0}%
        </span>
      )}
    </div>

  </div>
</section>

  {/* 11. VENDOR DETAILS - READ ONLY */}
  {/* <section>
    <div className="flex items-center gap-3 mb-4">
      <h3 className="text-md text-[1rem] font-semibold">Vendor Details</h3>
    </div>
    {vendor ? (
      <div className="bg-gradient-to-r from-gray-50 to-slate-50 border border-gray-200 rounded-3xl p-8 shadow-xl">
        <div className="flex gap-8 items-start">
          <div className="w-20 h-20 rounded-2xl flex-shrink-0 shadow-lg overflow-hidden border-4 border-white">
            {vendor.vendor_image ? (
              <img 
                src={`${imageUrl}${vendor.vendor_image}`} 
                alt={vendor.vendor_name} 
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <div className={`w-full h-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-black text-2xl flex-shrink-0 ${vendor.vendor_image ? 'hidden' : 'flex'}`}>
              {vendor.vendor_name?.charAt(0)?.toUpperCase() || 'V'}
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between mb-4">
              <h4 className="text-xl font-bold text-gray-900 truncate">{vendor.vendor_name}</h4>
              <div className="flex items-center gap-2 ml-4">
                <span className="px-3 py-1 bg-emerald-100 text-emerald-800 text-xs font-semibold rounded-full">
                  Active
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div className="flex items-center gap-3 p-3 bg-white rounded-xl shadow-sm">
                <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  🏢
                </div>
                <span className="text-sm font-semibold text-gray-900 truncate">{vendor.vendor_company}</span>
              </div>
                          {vendor.vendor_email && (
                <div className="flex items-center gap-3 p-3 bg-white rounded-xl shadow-sm">
                  <div className="w-10 h-10 bg-green-100 text-green-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    📧
                  </div>
                  <a href={`mailto:${vendor.vendor_email}`} className="text-sm text-blue-600 hover:text-blue-700 font-medium truncate">
                    {vendor.vendor_email}
                  </a>
                </div>
              )}
            </div>

            {vendor.vendor_address && (
              <div className="flex items-start gap-3 p-4 bg-indigo-50 rounded-2xl border border-indigo-200 mb-4">
                <div className="w-10 h-10 bg-indigo-100 text-indigo-600 rounded-xl flex items-center justify-center flex-shrink-0 mt-1">
                  📍
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs text-gray-500 block mb-1">Address</span>
                  <p className="text-sm font-medium text-gray-900 leading-relaxed">{vendor.vendor_address}</p>
                </div>
              </div>
            )}

            {vendor.vendor_pincode && (
              <div className="flex items-center gap-3 p-3 bg-rose-50 rounded-xl border border-rose-200">
                <div className="w-10 h-10 bg-rose-100 text-rose-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  📮
                </div>
                <span className="text-sm font-bold text-rose-800 bg-rose-200 px-3 py-1 rounded-full">
                  {vendor.vendor_pincode}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="p-12 text-center border-2 border-dashed border-gray-200 rounded-3xl bg-gradient-to-r from-gray-50 to-slate-50">
        <div className="w-20 h-20 bg-gray-200 rounded-3xl mx-auto flex items-center justify-center mb-4">
          <span className="text-gray-400 text-2xl">👤</span>
        </div>
        <span className="text-lg text-gray-400 font-medium block mb-2">No vendor assigned</span>
        <span className="text-sm text-gray-500">This item has no vendor information</span>
      </div>
    )}
  </section> */}
</div>

</div>


              </div>

<div className="flex flex-col items-center w-1/4 p-4">

    {/* ================= PRIMARY IMAGE ================= */}

    <div
        className="w-44 border border-dashed border-gray-300 rounded-lg p-3 cursor-pointer"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => document.getElementById("imageInput").click()}
    >

        <div className="flex justify-center">

            {imageSrc && selectedProduct.product_image ? (

                <img
                    src={imageSrc}
                    alt={selectedProduct.product_image}
                    className="w-32 h-32 rounded-lg object-cover"
                />

            ) : (

                <div className="w-32 h-32 rounded-lg bg-gray-100 flex items-center justify-center">

                    <FontAwesomeIcon
                        icon={faImage}
                        className="text-4xl text-gray-400"
                    />

                </div>

            )}

        </div>

        <div className="flex items-center justify-between mt-3">

            <span className="text-xs text-gray-500">
                Click or Drag
            </span>

            <FaRegTrashAlt
                className="cursor-pointer text-gray-500 hover:text-red-500"
                onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteItemImage(selectedProduct);
                }}
            />

        </div>

        <input
            id="imageInput"
            type="file"
            hidden
            accept="image/*"
            onChange={handleImageChange}
            onClick={handleFileInputClick}
        />

    </div>

    {isUploading && (
        <p className="mt-2 text-sm text-gray-500">
            Uploading...
        </p>
    )}

    {/* ================= GALLERY ================= */}

    <div className="mt-8 w-full">

        <h3 className="font-semibold text-center mb-4">
            Product Gallery
        </h3>

        {/* Preview */}

        <div className="mx-auto w-60 h-60 rounded-xl border bg-gray-50 flex items-center justify-center overflow-hidden">

            {existingImages.length ? (

                <img
                    src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}/${existingImages[currentGalleryIndex]?.image}`}
                    className="max-w-full max-h-full object-contain"
                />

            ) : (

                <span className="text-gray-400">
                    No Images
                </span>

            )}

        </div>

        {/* Thumbnails */}

        <div className="flex flex-wrap justify-center gap-3 mt-5">

            {existingImages.map((img, index) => (

                <div
                    key={img._id}
                    onClick={() => setCurrentGalleryIndex(index)}
                    className={`relative w-16 h-16 rounded-lg overflow-hidden cursor-pointer border-2 ${
                        currentGalleryIndex === index
                            ? "border-red-500"
                            : "border-gray-300"
                    }`}
                >

                    <img
                        src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}/${img.image}`}
                        className="w-full h-full object-cover"
                    />

                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteGalleryImage(img._id);
                        }}
                        className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-red-600 text-white text-xs"
                    >
                    <FontAwesomeIcon icon={faTrash} className="text-md text-white-500"/>
                    </button>

                </div>

            ))}

            {/* Add */}

            <label className="w-16 h-16 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer flex items-center justify-center hover:border-red-500">

                <FontAwesomeIcon
                    icon={faPlus}
                    className="text-xl text-gray-500"
                />

                <input
                    hidden
                    multiple
                    type="file"
                    accept="image/*"
                    onChange={handleGalleryImages}
                />

            </label>

        </div>

        {/* Dots */}

        {existingImages.length > 1 && (

            <div className="flex justify-center gap-2 mt-4">

                {existingImages.map((_, index) => (

                    <button
                        key={index}
                        onClick={() => setCurrentGalleryIndex(index)}
                        className={`w-2.5 h-2.5 rounded-full ${
                            currentGalleryIndex === index
                                ? "bg-red-500"
                                : "bg-gray-300"
                        }`}
                    />

                ))}

            </div>

        )}

    </div>

</div>

            </div>

                 {/* BOTTOM STICKY SAVE/CANCEL BAR - RIGHT SECTION ONLY */}
{isEditMode && selectedProduct && (
  <div className="relative">
    <div className="fixed bottom-0 right-0 left-[34%] bg-white border border-gray-200 shadow-sm z-[1000] rounded-md p-3 pl-4">
      
      <div className="flex justify-start items-center gap-4">

         {/* Save */}
        <button
          onClick={handleSaveEdit}
          disabled={isSaving || isPricingInvalid}
          className={`px-3 py-1.5 rounded-md text-sm font-medium transition flex items-center gap-1 ${
            isSaving || isPricingInvalid
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-[#f7525a] text-white hover:bg-[#e54643]'
          }`}
        >
          {isSaving ? (
            <>
              <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Saving
            </>
          ) : (
            'Save'
          )}
        </button>

        {/* Cancel */}
        <button
          onClick={handleCancelEdit}
          disabled={isSaving}
          className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300 rounded-md text-sm font-medium transition"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
    
          </div>     
  )}
        </>
      ) : (
        <div className="flex justify-center items-center h-full">
          <p className="text-gray-500">Select an Item to view details</p>
        </div>
      )}
  
</div>


{showPopup && (
  <div className="z-[9999]">
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup}/>}
  </div>
)}

{/* {showRequiredPopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-1/2 h-2/3 flex flex-col ">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md"> Attributes</h2>
        <button onClick={handleClosePopup} className="text-white px-1 py-1 rounded-md ">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer " />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      {attributeLoading ?(
          <>
          <Loader />
          </>
      ):(

     <>
      <div className="w-full flex flex-row items-center justify-center mb-4 space-x-2 mt-5 px-6">
         <label htmlFor="uom" className="block text-sm font-regular text-[#e54643] w-1/6">
          Attributes<span className="text-red-500">*</span>
        </label> 
        
      </div>

      <div className="w-full flex flex-row justify-center items-center mb-4 space-x-2 px-6">
      <div className="flex justify-center flex-col items-center">
        
      </div>
      </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md"
            onClick={handleAddattributesToGroup} >
            Save {isSaving && (
          <Spinner/>)}
            </button>
          <button onClick={handleClosePopup} className="px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">Cancel</button>
        </div>
      </div>
      </>
 )}
    </div>
  </div>
)} */}

       {showQuantityPricingPopup && (
  <div className="fixed inset-0 z-50 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-3/4 h-3/4 flex flex-col animate-slide-in">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md font-semibold">Quantity-based Pricing</h2>
        <button onClick={() => setShowQuantityPricingPopup(false)} className="text-white px-1 py-1 rounded-md">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer" />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      
      <div className="flex-grow overflow-auto p-6">
        <table className="w-full border-collapse">
          <thead>
            <tr className="text-[#6c7184] bg-[#fafafc]">
              <th className="font-semibold text-left text-sm py-2 px-4 border">Min Quantity</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Max Quantity</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Selling Price</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Cost Price</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {quantityPricingRows.map((row, index) => (
              <tr key={index}>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.minQuantity}
                    onChange={(e) => handleQuantityPricingChange(index, 'minQuantity', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Min"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.maxQuantity}
                    onChange={(e) => handleQuantityPricingChange(index, 'maxQuantity', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Max"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.sellingPrice}
                    onChange={(e) => handleQuantityPricingChange(index, 'sellingPrice', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Selling Price"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.costPrice}
                    onChange={(e) => handleQuantityPricingChange(index, 'costPrice', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Cost Price"
                  />
                </td>
                <td className="border p-2">
                  {quantityPricingRows.length > 0 && (
                    <button
                      type="button"
                      onClick={() => deleteQuantityPricingRow(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <div className="mt-4">
          <button
            onClick={addQuantityPricingRow}
            className="text-blue-500 py-2 px-4 hover:text-blue-700"
          >
            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
            Add Row
          </button>
        </div>
      </div>
      
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button 
            className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md"
            onClick={saveQuantityPricing}
          >
            Save
          </button>
          <button 
            onClick={() => setShowQuantityPricingPopup(false)} 
            className="px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{showAssignAttributesPopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
<div className="bg-white rounded-b-md shadow-md w-1/2 h-[70vh] flex flex-col">

      {/* HEADER */}
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md">Attributes</h2>

        <button onClick={handleCloseAttributePopup} className="text-white px-1 py-1 rounded-md">
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer" />
        </button>
      </div>

      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />

      {attributeLoading ? (
        <Loader />
      ) : (
        <>
           <div className="flex-1 overflow-y-auto w-full flex flex-col items-center px-6 py-4 space-y-4">   

            {/* ERROR MESSAGE */}
            {Object.keys(errors).length > 0 && (
              <div className="flex justify-between w-full p-2 items-center px-auto py-3 bg-[#fddcde] rounded-md">

                <div className="px-6 flex flex-col space-y-2 justify-start items-start">
                  {errors.assign_attribute && (
                    <span className="text-sm">• {errors.assign_attribute}</span>
                  )}
                </div>

                <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={() => setErrors({})}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                </div>

              </div>
            )}

            {/* ATTRIBUTES TABLE */}
            <div className="flex justify-center flex-col items-center">

              {productAttributes.length > 0 ? (

                <table>
                  <tbody>

                    {productAttributes.map((attribute, index) => (

                      <tr key={index} className='border-2 border-opacity-50'>

                        <td className='py-2 px-4 border-2 border-opacity-50'>
                          <h1 className='font-semibold'>
                            {attribute.attribute_name}
                          </h1>
                        </td>

                        <td>

                          <div className='flex flex-col text-sm items-left ml-10 px-4 py-2'>

{attribute.attribute_values.map((attributeValue, attributeValueIndex) => (
  <div key={`${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`} className='flex flex-row items-center py-1'>
    <input
      type='radio'
      id={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`}  // ✅ STABLE ID
      name={`attribute_${attribute.attribute_name_id}`}  // ✅ GROUP BY ATTRIBUTE
      onClick={() => {
        console.log('🖱️ RADIO CLICKED:', attribute.attribute_name, attributeValue.attribute_value);
        handleRadioChange(attribute.attribute_name_id, attributeValue.attribute_value_id);
      }}
      checked={attributeIds.some(id => 
        id.attribute_value_id === attributeValue.attribute_value_id
      )}
      className="w-4 h-4 accent-red-500 bg-gray-100 border-2 border-gray-400 rounded-full cursor-pointer focus:outline-none"
    />
    <label
      htmlFor={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`}
      className='ml-3 text-sm cursor-pointer hover:text-[#EB001B] select-none font-medium'
    >
      {attributeValue.attribute_value}
    </label>
  </div>
))}

                          </div>

                        </td>

                      </tr>

                    ))}

                  </tbody>
                </table>

              ) : (

                <div className="flex justify-center items-center h-64 w-full">
                  <span className="text-gray-500 text-sm">
                    No attributes available.
                  </span>
                </div>

              )}

            </div>

          </div>

          {/* FOOTER */}
          <div className="mt-auto w-full">

            <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />

            <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">

              <button
                className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
                onClick={handleAddattributesToItem}
              >
                <span>Save</span>
                {Saving && (<Spinner />)}
              </button>

              <button
                onClick={handleCloseAttributePopup}
                className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
                  isSaving
                    ? 'bg-gray-400 text-gray-500 cursor-not-allowed'
                    : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
                }`}
                disabled={Saving}
              >
                Cancel
              </button>

            </div>

          </div>
        </>
      )}

    </div>
  </div>

)}

{/* 🔥 DIRECT USAGE - PASTE THIS EXACTLY */}
{Object.keys(validationErrors).length > 0 && (
  <div className="p-1">
    <div className="mt-1 flex justify-between items-center bg-[#fddcde] rounded-md py-1">
      {/* Error List */}
      <div className="px-6 flex flex-col justify-start items-start">
        {Object.entries(validationErrors).map(([field, message], index) => (
          <span key={index} className="text-sm text-[#7a1c1f]">
            - {message}
          </span>
        ))}
      </div>

      {/* Close Button */}
      <div className="px-4">
        <button
          className="text-gray-700 hover:text-red-500"
          onClick={() => {
            setValidationErrors({});
            setShowValidationErrors(false);
          }}
        >
          <FontAwesomeIcon
            icon={faX}
            className="text-xs text-[#F7525A] cursor-pointer"
          />
        </button>
      </div>
    </div>
  </div>
)}
    </div>

  );

};



export default ViewProductDetails;